(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('lodash')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'lodash'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = {}), global.React, global.PropTypes, global._));
})(this, (function (exports, React, PropTypes, _) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
  var ___default = /*#__PURE__*/_interopDefaultLegacy(_);

  function _typeof$2(obj) {
    "@babel/helpers - typeof";

    return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$2(obj);
  }

  function _toPrimitive(input, hint) {
    if (_typeof$2(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (_typeof$2(res) !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }

  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof$2(key) === "symbol" ? key : String(key);
  }

  function _defineProperty$2(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }

  function _arrayWithHoles$1(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit$1(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
      var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;
      try {
        if (_x = (_i = _i.call(arr)).next, 0 === i) {
          if (Object(_i) !== _i) return;
          _n = !1;
        } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
      } catch (err) {
        _d = !0, _e = err;
      } finally {
        try {
          if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
        } finally {
          if (_d) throw _e;
        }
      }
      return _arr;
    }
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _nonIterableRest$1() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _slicedToArray$1(arr, i) {
    return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest$1();
  }

  function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === 'undefined') {
      return;
    }
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';
    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z$a = "/* Consolidation of frequently used colours throughout the repo */\n.checkbox_container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n}\n.checkbox_container .input_container {\n  display: block;\n  position: relative;\n  padding-left: 18px;\n  margin-bottom: 18px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n.checkbox_container .input_container input {\n  cursor: pointer;\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  height: 18px;\n  width: 18px;\n}\n.checkbox_container .input_container input:checked ~ .checkmark {\n  background-color: #051d33;\n}\n.checkbox_container .input_container input:checked ~ .checkmark.disable {\n  background-color: #eeeeee;\n}\n.checkbox_container .input_container input:checked ~ .checkmark.disable:after {\n  border: solid #051d33;\n  border-width: 0 3px 3px 0;\n}\n.checkbox_container .input_container input:checked ~ .checkmark:after {\n  display: block;\n}\n.checkbox_container .input_container .checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: #ffffff;\n  border: 1px solid #c3c3c3;\n  border-radius: 2px;\n  color: transparent;\n}\n.checkbox_container .input_container .checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 5px;\n  top: 1px;\n  width: 7px;\n  height: 11px;\n  border: solid #ffffff;\n  border-width: 0 3px 3px 0;\n  transform: rotate(45deg);\n}\n.checkbox_container .input_container .check-error {\n  border: 1px solid #ab1212;\n}\n.checkbox_container .input_container .checkmark.disable {\n  background-color: #eeeeee;\n}\n.checkbox_container.disabled > .input_container,\n.checkbox_container.disabled .child_container {\n  cursor: not-allowed !important;\n}\n.checkbox_container.disabled > .input_container input,\n.checkbox_container.disabled .child_container input {\n  cursor: not-allowed !important;\n}\n.checkbox_container.is_label_left {\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  width: unset;\n}\n.checkbox_container.is_label_left .input_container {\n  padding-left: unset;\n}\n.checkbox_container.is_label_left .child_container {\n  padding-left: unset;\n  padding-right: 0.5rem;\n}\n.checkbox_container .child_container {\n  padding-left: 0.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n}";
  styleInject(css_248z$a);

  function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var CheckBox = function CheckBox(props) {
    var name = props.name,
      changeHandler = props.changeHandler,
      isDisabled = props.isDisabled,
      children = props.children,
      value = props.value,
      ischecked = props.ischecked,
      id = props.id,
      tabIndex = props.tabIndex,
      errorMessage = props.errorMessage,
      labelText = props.labelText,
      isLabelLeft = props.isLabelLeft,
      labelStyle = props.labelStyle;
    var _useState = React.useState(ischecked),
      _useState2 = _slicedToArray$1(_useState, 2),
      isSelected = _useState2[0],
      setSelected = _useState2[1];
    var checkBoxRef = React.useRef(null);
    React.useEffect(function () {
      setSelected(ischecked);
    }, [ischecked]);
    var handleClick = function handleClick(e) {
      setSelected(false);
      e.persist();
      if (e.target.checked) {
        setSelected(true);
        changeHandler(true);
      } else {
        setSelected(false);
        changeHandler(false);
      }
    };
    var handleLableClick = function handleLableClick(flag) {
      if (!flag) {
        var node = checkBoxRef.current;
        setSelected(!isSelected);
        node.checked = !isSelected;
        changeHandler(!isSelected);
      }
    };
    var idCheckbox;
    if (id === null) {
      idCheckbox = "checkbox_".concat(Math.floor(Math.random() * 100000));
    } else {
      idCheckbox = id;
    }
    var handleKeyPress = function handleKeyPress(e) {
      e.persist();
      if (e.key === 'Enter') {
        handleLableClick(isDisabled);
      }
    };
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "checkbox_container ".concat(isDisabled && 'disabled', " ").concat(isLabelLeft && 'is_label_left')
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input_container"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      id: idCheckbox,
      ref: checkBoxRef,
      type: "checkbox",
      name: name,
      value: value,
      disabled: isDisabled,
      onClick: handleClick,
      checked: isSelected,
      onChange: function onChange() {
        return null;
      },
      tabIndex: "-1"
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "checkmark ".concat(isDisabled && 'disable', " ").concat(errorMessage !== null && 'check-error'),
      onClick: changeHandler,
      tabIndex: tabIndex,
      onKeyPress: handleKeyPress,
      "aria-label": labelText
    })), /*#__PURE__*/React__default["default"].createElement("label", {
      "aria-label": labelText,
      htmlFor: idCheckbox,
      className: "child_container",
      style: _objectSpread$2({}, labelStyle)
    }, children || labelText));
  };
  CheckBox.propTypes = {
    value: PropTypes__default["default"].string,
    children: PropTypes__default["default"].any,
    name: PropTypes__default["default"].string,
    changeHandler: PropTypes__default["default"].func,
    isDisabled: PropTypes__default["default"].bool,
    ischecked: PropTypes__default["default"].bool,
    id: PropTypes__default["default"].string,
    tabIndex: PropTypes__default["default"].string,
    errorMessage: PropTypes__default["default"].string,
    labelText: PropTypes__default["default"].string,
    labelStyle: PropTypes__default["default"].object,
    isLabelLeft: PropTypes__default["default"].bool
  };
  CheckBox.defaultProps = {
    value: '',
    children: '',
    name: '',
    changeHandler: function changeHandler() {
      return null;
    },
    isDisabled: false,
    ischecked: false,
    id: null,
    tabIndex: '0',
    errorMessage: null,
    labelText: '',
    labelStyle: {},
    isLabelLeft: false
  };

  var css_248z$9 = ".dateInput, .dateRangeInput {\n  min-width: 150px;\n  width: 100%;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid #c3c3c3;\n  padding: 0.575rem 0.75rem;\n  line-height: normal;\n  outline: none;\n  cursor: pointer;\n}\n.dateInput:focus, .dateRangeInput:focus {\n  border: 1px solid #00677f;\n}\n.dateInput:hover, .dateRangeInput:hover {\n  margin: 0;\n  border: 1px solid #00677f;\n  outline: 0;\n  background: #f3fafd;\n}\n.dateInput:disabled, .dateRangeInput:disabled {\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}\n.dateInput.disable, .disable.dateRangeInput {\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}\n\n.dateRangeInput.disable {\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}";
  styleInject(css_248z$9);

  var DateInput = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
    var lang = props.lang,
      date = props.date,
      dateFormat = props.dateFormat,
      styles = props.styles,
      disable = props.disable;
    var checkedDate = Object.prototype.toString.call(date) === '[object Date]' ? date : new Date();
    return /*#__PURE__*/React__default["default"].createElement("span", {
      className: "dateInput ".concat(disable ? 'disable' : ''),
      style: styles,
      ref: ref
    }, checkedDate.toLocaleDateString("".concat(lang, "-CA"), dateFormat));
  });
  DateInput.propTypes = {
    lang: PropTypes__default["default"].string,
    date: PropTypes__default["default"].instanceOf(Date),
    dateFormat: PropTypes__default["default"].object,
    styles: PropTypes__default["default"].object,
    disable: PropTypes__default["default"].bool
  };
  DateInput.defaultProps = {
    lang: 'en',
    date: null,
    dateFormat: {
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    },
    styles: {},
    disable: false
  };
  var DateRangeInput = /*#__PURE__*/React__default["default"].forwardRef(function (props, ref) {
    var lang = props.lang,
      startDate = props.startDate,
      endDate = props.endDate,
      dateFormat = props.dateFormat,
      styles = props.styles,
      disable = props.disable;
    var yesterday = new Date();
    var today = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    var checkedStartDate = Object.prototype.toString.call(startDate) === '[object Date]' ? startDate : yesterday;
    var checkedEndDate = Object.prototype.toString.call(endDate) === '[object Date]' ? endDate : today;
    return /*#__PURE__*/React__default["default"].createElement("span", {
      className: "dateRangeInput ".concat(disable ? 'disable' : ''),
      style: styles,
      ref: ref
    }, "".concat(checkedStartDate.toLocaleDateString("".concat(lang, "-CA"), dateFormat), " - ").concat(checkedEndDate.toLocaleDateString("".concat(lang, "-CA"), dateFormat)));
  });
  DateRangeInput.propTypes = {
    lang: PropTypes__default["default"].string,
    startDate: PropTypes__default["default"].instanceOf(Date),
    endDate: PropTypes__default["default"].instanceOf(Date),
    dateFormat: PropTypes__default["default"].object,
    styles: PropTypes__default["default"].object,
    disable: PropTypes__default["default"].bool
  };
  DateRangeInput.defaultProps = {
    lang: 'en',
    startDate: null,
    endDate: null,
    dateFormat: {
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    },
    styles: {},
    disable: false
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  var dist$2 = {exports: {}};

  (function (module, exports) {
  (function (global, factory) {
    factory(exports, React__default["default"], PropTypes__default["default"]) ;
  })(commonjsGlobal, (function (exports, React, PropTypes) {
    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

    var ActiveExistingMerchantIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { className: 'a', d: 'M0-38.1h82.173v82.173H0z', transform: 'translate(0 38.1)' }))),
            React__default["default"].createElement("g", { "clip-path": 'url(#a)' },
                React__default["default"].createElement("path", { className: 'a', d: 'M53.261 56.36v-7.516a.761.761 0 00-1.522 0v5.326c-1.469 0-3.043-2.679-3.043-4.565V41.83c6.674 2.5 9.13 8.014 9.13 12.34 0 1.109-1.576 1.859-4.565 2.19m-12.929 2.375c-4.892 0-10.254-.624-11.419-1.815v-1.229c3.072 0 4.565-1.991 4.565-6.087h13.7c0 2.452 1.917 6.087 4.565 6.087v1.017c-.026.027-.06.044-.081.076-.915 1.34-6.512 1.95-11.326 1.95M22.821 54.17c0-4.326 2.456-9.839 9.13-12.337v7.771c0 4.212-1.571 4.565-3.043 4.565v-5.325a.761.761 0 00-.761-.761.761.761 0 00-.761.761v7.532c-3.018-.313-4.565-1.05-4.565-2.206m12.922-8.048a.755.755 0 00.583.489.746.746 0 00.717-.259l3.292-3.941 3.409 3.95a.759.759 0 00.576.264.789.789 0 00.145-.014.763.763 0 00.575-.5l1.666-4.9c.158.04.313.083.467.126v6.745h-13.7v-6.741c.162-.046.326-.089.492-.132zm-.422-6.871l3.838 2.193-2.438 2.915-1.66-4.6zm5-.3a5.643 5.643 0 003.837-1.742 5.724 5.724 0 00.161.871l-3.998 2.279-3.982-2.278a5.869 5.869 0 00.155-.87 5.642 5.642 0 003.827 1.741m-5.734-7.524a4.113 4.113 0 01-1.109-2.367c0-1.3.236-1.522.761-1.522a11.014 11.014 0 007.421-3.254c.747 1.268 2.306 3.254 4.752 3.254.526 0 .761.22.761 1.522a4.1 4.1 0 01-1.107 2.365.762.762 0 00-.369.425c-1.186 3.337-3.343 5.58-5.376 5.58s-4.181-2.243-5.365-5.58a.762.762 0 00-.369-.423m5.734-12.258c5.2 0 6.491 4.13 6.773 6.944a2.582 2.582 0 00-.686-.1c-2.485 0-3.846-3.294-3.859-3.327a.761.761 0 00-.6-.468.755.755 0 00-.7.276c-.027.036-2.863 3.519-7.014 3.519a2.572 2.572 0 00-.686.1c.286-2.817 1.582-6.944 6.772-6.944m5.014 20.082l.256.515-1.563 4.593-2.522-2.922zm1.825.507a.741.741 0 00-.065-.384l-.755-1.522a.636.636 0 00-.606-.4 3.96 3.96 0 01-.082-.78v-1.291a14.194 14.194 0 001.405-2.82 5.54 5.54 0 001.638-3.5 5.694 5.694 0 00-.112-1.147.744.744 0 00.112-.374c0-6.195-3.129-9.891-8.37-9.891s-8.37 3.7-8.37 9.891a.744.744 0 00.112.374 5.694 5.694 0 00-.112 1.147 5.541 5.541 0 001.639 3.5 14.152 14.152 0 001.4 2.82v1.288a4.119 4.119 0 01-.078.78.821.821 0 00-.143.014.762.762 0 00-.46.388l-.761 1.522a.749.749 0 00-.065.39c-8.966 2.301-12.183 9.133-12.183 14.406 0 3.125 4.551 3.63 6.481 3.779 2.055 2.075 9.384 2.308 12.547 2.308 3.1 0 10.285-.233 12.328-2.308 1.983-.152 6.687-.664 6.687-3.779 0-5.267-3.218-12.111-12.188-14.41', fill: '#00677F' }))));
    };
    ActiveExistingMerchantIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ActiveExistingMerchantIcon.defaultProps = {
        width: '84',
        height: '84'
    };

    var CheckIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { d: 'M0-16.556h34.409v34.409H0z', transform: 'translate(0 16.556)' })),
                React__default["default"].createElement("clipPath", { id: 'b' },
                    React__default["default"].createElement("path", { d: 'M34.409 17.853z', transform: 'translate(0 16.556)' }))),
            React__default["default"].createElement("path", { style: { fill: 'none', stroke: '#1da897', strokeWidth: '1.25px' }, d: 'M17.423 30.108a12.903 12.903 0 010-25.807 12.903 12.903 0 110 25.807' }),
            React__default["default"].createElement("g", { "clip-path": 'url(#b)', transform: 'translate(.218)' },
                React__default["default"].createElement("path", { style: { fill: 'none', stroke: '#1da897', strokeWidth: '1.25px' }, d: 'M17.205 30.108a12.903 12.903 0 010-25.807 12.903 12.903 0 110 25.807' })),
            React__default["default"].createElement("g", null,
                React__default["default"].createElement("path", { d: 'M9.057 18.799l6.523 5.554 9.258-13.965', "stroke-linecap": 'round', "stroke-linejoin": 'round', "stroke-width": '1.06', fill: 'none', stroke: '#1da897' }))));
    };
    CheckIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    CheckIcon.defaultProps = {
        width: '34.627',
        height: '34.409'
    };

    var ChevronCancel = function (props) { return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '48.08', height: '48.08', viewBox: '0 0 12.721 12.721' },
        React__default["default"].createElement("defs", null,
            React__default["default"].createElement("clipPath", { id: 'a', clipPathUnits: 'userSpaceOnUse' },
                React__default["default"].createElement("path", { d: 'M0 72h72V0H0z' })),
            React__default["default"].createElement("clipPath", { id: 'b', clipPathUnits: 'userSpaceOnUse' },
                React__default["default"].createElement("path", { d: 'M0 72h72V0H0z' }))),
        React__default["default"].createElement("g", { "clip-path": 'url(#a)', transform: 'matrix(.22994 0 0 -.22994 -1.903 14.644)', fill: 'none', stroke: '#ef413d' },
            React__default["default"].createElement("path", { d: 'M36 9C21.112 9 9 21.115 9 36 9 50.89 21.112 63 36 63S63 50.89 63 36C63 21.115 50.888 9 36 9', "stroke-width": '2.175' })),
        React__default["default"].createElement("g", { "clip-path": 'url(#b)', transform: 'matrix(.22994 0 0 -.22994 -2.008 14.644)', fill: '#ef413d' },
            React__default["default"].createElement("path", { d: 'M37.956 36.001l12.91 12.908a1.175 1.175 0 010 1.662l-.297.295a1.175 1.175 0 01-1.662 0L36 37.959 23.091 50.866a1.175 1.175 0 01-1.662 0l-.297-.295a1.175 1.175 0 010-1.662L34.04 36.001 21.132 23.092a1.175 1.175 0 010-1.662l.297-.295a1.175 1.175 0 011.662 0L36 34.043l12.908-12.908a1.175 1.175 0 011.662 0l.297.295a1.175 1.175 0 010 1.662z' })))); };

    var ChevronClose = function (props) {
        var width = props.width, height = props.height, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { style: { fill: color }, d: 'M0-25.4h30.758V5.358H0z', transform: 'translate(0 25.4)' }))),
            React__default["default"].createElement("g", { clipPath: 'url(#a)' },
                React__default["default"].createElement("path", { style: { fill: color }, d: 'M16.216 15.379l5.515-5.514a.5.5 0 000-.71l-.127-.126a.5.5 0 00-.71 0l-5.514 5.518-5.515-5.518a.5.5 0 00-.71 0l-.127.126a.5.5 0 000 .71l5.51 5.514-5.51 5.515a.5.5 0 000 .71l.127.126a.5.5 0 00.71 0l5.515-5.515 5.514 5.515a.5.5 0 00.71 0l.127-.126a.5.5 0 000-.71z' }))));
    };
    ChevronClose.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    ChevronClose.defaultProps = {
        width: '30.758',
        height: '30.758',
        color: '#fff'
    };

    var ChevronCopyIcon = function (props) {
        var width = props.width, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, viewBox: '0 0 20.322 12.594' },
            React__default["default"].createElement("g", { transform: 'matrix(.28623 0 0 -.28623 -5.617 22.458)', fill: color },
                React__default["default"].createElement("path", { d: 'M57.278 60.201c.555 0 1.004.45 1.004 1.002v.046a1.003 1.003 0 01-2.008 0v-.046c0-.553.45-1.002 1.004-1.002M57.278 63.678c.555 0 1.004.448 1.004 1.002v.096a1.003 1.003 0 01-2.008 0v-.096c0-.554.45-1.002 1.004-1.002M57.278 70.731c.555 0 1.004.45 1.004 1.003v.096c0 .554-.449 1.002-1.004 1.002a1.003 1.003 0 01-1.004-1.002v-.096c0-.554.45-1.003 1.004-1.003M57.278 67.204c.555 0 1.004.45 1.004 1.003v.096a1.003 1.003 0 01-2.008 0v-.096c0-.554.45-1.003 1.004-1.003M57.196 74.263a1.002 1.002 0 011.092.905l.007.057a1.003 1.003 0 01-1.99.265l-.015-.136a1.001 1.001 0 01.906-1.091M59.665 76.453H59.749a1.002 1.002 0 110 2.006h-.045l-.005-.002-.005.002h-.047a1.004 1.004 0 01.018-2.006M69.83 78.459h-.093a1.004 1.004 0 110-2.006h.092a1.003 1.003 0 110 2.006M76.55 78.459h-.093a1.004 1.004 0 01-1.004-1.003c0-.554.45-1.003 1.004-1.003h.093a1.004 1.004 0 010 2.006M79.473 76.523a.982.982 0 01.444-.114c.553 0 1.003.448 1.003 1.003v.045c0 .552-.45 1.002-1.003 1.002h-.004a.004.004 0 00-.003 0h-.092c-.555 0-1.004-.45-1.004-1.002 0-.433.275-.793.659-.934M84.19 72.577a1.003 1.003 0 011.42 1.417l-.066.066a1.003 1.003 0 01-1.419-1.417zM86.566 70.204a1.003 1.003 0 011.42 1.417l-.066.066a1.002 1.002 0 11-1.419-1.418zM81.814 74.95a1.003 1.003 0 011.42 1.418l-.066.065a1.003 1.003 0 01-1.419-1.418zM66.377 76.453h.093c.553 0 1.004.45 1.004 1.003 0 .554-.451 1.003-1.004 1.003h-.093a1.003 1.003 0 110-2.006M73.189 78.459h-.092a1.004 1.004 0 01-1.004-1.003c0-.554.45-1.003 1.003-1.003h.093a1.003 1.003 0 110 2.006M63.017 76.453h.093c.553 0 1.004.45 1.004 1.003 0 .554-.451 1.003-1.004 1.003h-.093a1.004 1.004 0 010-2.006M90.622 68.572c0 .264-.105.521-.293.71l-.03.03a1.004 1.004 0 01-1.42.002.994.994 0 01-.202-1.117.983.983 0 01-.108-.433c0-.553.45-1.003 1.004-1.003h.045a1.004 1.004 0 01.927 1.385c.05.117.077.246.077.381zM58.323 37.543l-.012.052a1.003 1.003 0 01-1.966-.406l.03-.124a1.003 1.003 0 111.949.478M59.743 36.464h-.068a1.002 1.002 0 11-.04-2.005H59.742a1.003 1.003 0 110 2.005M57.278 39.557c.555 0 1.004.449 1.004 1.002v.09a1.003 1.003 0 01-2.008 0v-.09c0-.553.45-1.002 1.004-1.002M58.282 47.17a1.003 1.003 0 01-2.008 0v-.09a1.004 1.004 0 012.008 0zM57.278 44.912a1.004 1.004 0 01-1.004-1.003v-.089c0-.554.45-1.002 1.004-1.002.555 0 1.004.448 1.004 1.002v.09c0 .553-.449 1.002-1.004 1.002M63.009 36.464h-.09a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M89.618 50.053a1.002 1.002 0 01-1.003-1.002v-.09a1.003 1.003 0 112.007 0v.09c0 .554-.449 1.002-1.004 1.002M89.618 66.358a1.003 1.003 0 01-1.003-1.003v-.089a1.004 1.004 0 012.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 43.531a1.003 1.003 0 01-1.003-1.002v-.09a1.003 1.003 0 012.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 46.793a1.003 1.003 0 01-1.003-1.003v-.089a1.004 1.004 0 012.007 0v.089c0 .554-.449 1.003-1.004 1.003M89.618 40.27a1.003 1.003 0 01-1.003-1.003v-.089a1.003 1.003 0 112.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 53.315a1.003 1.003 0 01-1.003-1.002v-.09a1.003 1.003 0 012.007 0v.09c0 .552-.449 1.001-1.004 1.001M89.618 59.836a1.003 1.003 0 01-1.003-1.002v-.09a1.003 1.003 0 012.007 0v.09c0 .553-.449 1.002-1.004 1.002M89.618 63.098a1.003 1.003 0 01-1.003-1.003v-.09a1.003 1.003 0 112.007 0v.09c0 .554-.449 1.003-1.004 1.003M89.618 56.575a1.002 1.002 0 01-1.003-1.003v-.088a1.003 1.003 0 112.007 0v.088c0 .555-.449 1.003-1.004 1.003M88.21 36.89l-.037-.036a1 1 0 01-.037-1.417 1.004 1.004 0 011.418-.036l.09.088a1.003 1.003 0 11-1.434 1.402M82.597 36.464h-.09a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 110 2.005M72.802 36.464h-.09a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M69.538 36.464h-.09a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 010 2.005M66.272 36.464h-.089a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 110 2.005M79.331 36.464h-.089a1.004 1.004 0 110-2.005h.09a1.003 1.003 0 110 2.005M76.067 36.464h-.09a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M85.86 36.464h-.089a1.003 1.003 0 110-2.005h.09a1.003 1.003 0 110 2.005M58.282 50.401a1.003 1.003 0 01-2.008 0v-.045a1.004 1.004 0 012.008 0zM80.92 74.44a1.004 1.004 0 01-2.007 0v-.084a1.003 1.003 0 012.008 0zM86.592 68.768h-.083a1.003 1.003 0 110-2.005h.083a1.003 1.003 0 110 2.005M83.533 68.768h-.083a1.003 1.003 0 110-2.005h.083a1.003 1.003 0 110 2.005M79.917 72.387a1.003 1.003 0 01-1.004-1.002V71.3c0-.554.449-1.002 1.004-1.002.554 0 1.004.448 1.004 1.002v.084c0 .553-.45 1.002-1.004 1.002M81.353 69.168l-.035.035a1.003 1.003 0 11-1.445-1.391l.084-.083a1.003 1.003 0 111.396 1.439M51.352 68.768H45.69a1.423 1.423 0 00-1.422 1.42v5.656zm1.615-17.363a1.003 1.003 0 01-1.005-1.003V37.885a1.424 1.424 0 00-1.42-1.421h-27.49a1.424 1.424 0 00-1.422 1.42v37.15a1.424 1.424 0 001.422 1.42H42.26v-6.266a3.428 3.428 0 013.43-3.425h6.272v-6.67a1.003 1.003 0 012.007 0v8.48c0 .264-.107.523-.293.709l-8.894 8.883a1.013 1.013 0 01-.71.294h-21.02a3.429 3.429 0 01-3.43-3.425v-37.15a3.429 3.429 0 013.43-3.425h27.49a3.428 3.428 0 013.427 3.426v12.517c0 .554-.449 1.003-1.003 1.003' }),
                React__default["default"].createElement("path", { d: 'M66.983 56.25H45.151a1.003 1.003 0 110-2.006h21.832l-4.756-4.748a1.006 1.006 0 010-1.418 1.006 1.006 0 011.42 0l6.468 6.461a1.009 1.009 0 01.217 1.092c-.05.119-.122.224-.21.315l-.007.01-6.468 6.461a1.004 1.004 0 01-1.42 0 1.004 1.004 0 010-1.417z' }))));
    };
    ChevronCopyIcon.propTypes = {
        width: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    ChevronCopyIcon.defaultProps = {
        width: '30',
        color: '#ffffff'
    };

    var ChevronDown = function (props) {
        var width = props.width, height = props.height, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M6 6.694a.693.693 0 01-.492-.2l-5.3-5.3a.695.695 0 01.983-.983L6 5.017 10.814.204a.695.695 0 01.983.983l-5.305 5.3A.692.692 0 016 6.694z', fill: color })));
    };
    ChevronDown.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    ChevronDown.defaultProps = {
        width: '12',
        height: '6.6',
        color: '#051d33'
    };

    var ChevronExpired = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M13.686 10.078L8.749 1.002a2.047 2.047 0 00-3.521 0L.291 10.078a2.046 2.046 0 001.76 3.093h9.874a2.047 2.047 0 001.761-3.093zm-6.7 1.455a.819.819 0 11.819-.819.82.82 0 01-.817.818zm.819-3.276a.819.819 0 11-1.638 0V4.162a.819.819 0 111.638 0z', fill: '#ab1212' })));
    };
    ChevronExpired.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ChevronExpired.defaultProps = {
        width: '13.976',
        height: '13.17'
    };

    var ChevronExpiredWarning = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M13.686 10.078L8.749 1.002a2.047 2.047 0 00-3.521 0L.291 10.078a2.046 2.046 0 001.76 3.093h9.874a2.047 2.047 0 001.761-3.093zm-6.7 1.455a.819.819 0 11.819-.819.82.82 0 01-.817.818zm.819-3.276a.819.819 0 11-1.638 0V4.162a.819.819 0 111.638 0z', fill: '#ffc107' })));
    };
    ChevronExpiredWarning.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ChevronExpiredWarning.defaultProps = {
        width: '13.976',
        height: '13.17'
    };

    var ChevronInfo = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { d: 'M0-25.776h37.118v37.118H0z', transform: 'translate(0 25.776)' }))),
            React__default["default"].createElement("g", { clipPath: 'url(#a)' },
                React__default["default"].createElement("circle", { cx: '8.385', cy: '8.385', r: '8.385', transform: 'translate(10.165 9.816)', fill: 'none', stroke: '#051d33', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1.037' }),
                React__default["default"].createElement("path", { style: { fill: '#051d33' }, d: 'M18.533 11.705a1.653 1.653 0 011.653 1.648 1.653 1.653 0 01-1.653 1.657 1.653 1.653 0 01-1.652-1.657 1.653 1.653 0 011.652-1.648zm2.718 12.228h-5.435V22.51h1.475v-4.637h-1.475v-1.42h4.091v6.06h1.344z' }))));
    };
    ChevronInfo.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ChevronInfo.defaultProps = {
        width: '37.118',
        height: '37.118'
    };

    var ChevronLeft = function (props) {
        var width = props.width, height = props.height, enable = props.enable, variant = props.variant;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M0 7.793a.9.9 0 01.264-.639l6.89-6.89a.903.903 0 111.277 1.277L2.179 7.793l6.252 6.252a.903.903 0 11-1.277 1.277L.267 8.431A.9.9 0 010 7.793z', fill: enable ? (variant === 'outline' ? '#051D33' : '#ffffff') : '#afa3a3' })));
    };
    ChevronLeft.propTypes = {
        variant: PropTypes__default["default"].string,
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        enable: PropTypes__default["default"].bool
    };
    ChevronLeft.defaultProps = {
        width: '8.695',
        height: '15.586',
        enable: true,
        variant: 'outline'
    };

    var ChevronLock = function (props) {
        var width = props.width, height = props.height, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("g", { fill: color, stroke: color },
                React__default["default"].createElement("path", { d: 'M11.482 5.857h-1.339V4.518a4.018 4.018 0 00-8.036 0v1.339H.768a.268.268 0 00-.268.268v8.3A1.073 1.073 0 001.571 15.5h9.107a1.073 1.073 0 001.071-1.071v-8.3a.268.268 0 00-.268-.268m-8.84-1.339a3.482 3.482 0 016.965 0v1.339H2.643zm8.572 9.911a.537.537 0 01-.536.536H1.571a.536.536 0 01-.536-.536v-8.04h10.18z' }),
                React__default["default"].createElement("path", { d: 'M6.126 8.769a.886.886 0 00-.3 1.723v2.129a.3.3 0 10.593 0v-2.129a.886.886 0 00-.3-1.723m0 1.185a.3.3 0 11.3-.3.3.3 0 01-.3.3' }))));
    };
    ChevronLock.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    ChevronLock.defaultProps = {
        width: '12.25',
        height: '16',
        color: '#ffffff'
    };

    var ChevronPlus = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("g", { transform: 'translate(0 2)', fill: '#00677f', stroke: '#00677f' },
                React__default["default"].createElement("circle", { cx: '8.5', cy: '8.5', r: '8.5', stroke: 'none' }),
                React__default["default"].createElement("circle", { cx: '8.5', cy: '8.5', r: '8', fill: 'none' })),
            React__default["default"].createElement("text", { transform: 'translate(3 16)', fill: '#fff', fontSize: '16', fontFamily: 'AvenirLTStd-Heavy,Avenir LT Std', fontWeight: '800' },
                React__default["default"].createElement("tspan", { x: '1', y: '0' }, "+"))));
    };
    ChevronPlus.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ChevronPlus.defaultProps = {
        width: '17',
        height: '19'
    };

    var ChevronRight = function (props) {
        var width = props.width, height = props.height, enable = props.enable, variant = props.variant;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M8.695 7.793a.9.9 0 01-.264.639l-6.89 6.89a.903.903 0 11-1.277-1.277l6.252-6.252L.264 1.541A.903.903 0 111.541.264l6.887 6.891a.9.9 0 01.267.638z', fill: enable ? (variant === 'outline' ? '#051D33' : '#ffffff') : '#afa3a3' })));
    };
    ChevronRight.propTypes = {
        variant: PropTypes__default["default"].string,
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        enable: PropTypes__default["default"].bool
    };
    ChevronRight.defaultProps = {
        width: '8.695',
        height: '15.586',
        enable: true,
        variant: 'outline'
    };

    var ChevronSearch = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { className: 'a', d: 'M0-25.4h28.919V3.519H0z', transform: 'translate(0 25.4)' }))),
            React__default["default"].createElement("g", { clipPath: 'url(#a)' },
                React__default["default"].createElement("path", { className: 'a', style: { fill: '#808285' }, d: 'M6.023 12.517a6.828 6.828 0 0113.656 0 6.828 6.828 0 11-13.656 0M24.469 23l-5.69-5.69a7.629 7.629 0 10-13.562-4.793 7.64 7.64 0 007.632 7.631 7.594 7.594 0 004.794-1.7l5.689 5.689z' }))));
    };
    ChevronSearch.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ChevronSearch.defaultProps = {
        width: '28.919',
        height: '28.919'
    };

    var ChevronUp = function (props) {
        var width = props.width, height = props.height, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M5.999 0a.693.693 0 01.492.2l5.3 5.3a.695.695 0 01-.983.983L5.999 1.677 1.185 6.49a.695.695 0 01-.983-.983l5.305-5.3A.692.692 0 015.999 0z', fill: color })));
    };
    ChevronUp.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    ChevronUp.defaultProps = {
        width: '12',
        height: '6.695',
        color: '#051d33'
    };

    var CollapseIcon = function (props) {
        var width = props.width, height = props.height, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M5.999 0a.693.693 0 01.492.2l5.3 5.3a.695.695 0 01-.983.983L5.999 1.677 1.185 6.49a.695.695 0 01-.983-.983l5.305-5.3A.692.692 0 015.999 0z', fill: color })));
    };
    CollapseIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    CollapseIcon.defaultProps = {
        width: '12',
        height: '6.695',
        color: '#C3C3C3'
    };

    var CrossIcon = function (props) {
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg' },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a', clipPathUnits: 'userSpaceOnUse' },
                    React__default["default"].createElement("path", { d: 'M0 72h72V0H0z' }))),
            React__default["default"].createElement("g", { clipPath: 'url(#a)', transform: 'matrix(.17266 0 0 -.17266 -3.59 8.842)' },
                React__default["default"].createElement("path", { d: 'M37.956 36.001l12.91 12.908a1.175 1.175 0 010 1.662l-.297.295a1.175 1.175 0 01-1.662 0L36 37.959 23.091 50.866a1.175 1.175 0 01-1.662 0l-.297-.295a1.175 1.175 0 010-1.662L34.04 36.001 21.132 23.092a1.175 1.175 0 010-1.662l.297-.295a1.175 1.175 0 011.662 0L36 34.043l12.908-12.908a1.175 1.175 0 011.662 0l.297.295a1.175 1.175 0 010 1.662z', fill: '#ef413d' }))));
    };
    CrossIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    CrossIcon.defaultProps = {
        width: '25',
        height: '25'
    };

    var ErrorIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null),
            React__default["default"].createElement("circle", { cx: '27', cy: '27', r: '27', fill: '#ab1212' }),
            React__default["default"].createElement("path", { style: { fill: '#fff', stroke: '#fff', strokeLinecap: 'round', strokeWidth: '2px' }, d: 'M15.5 15.5l23 23M15.5 38.5l23-23' })));
    };
    ErrorIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ErrorIcon.defaultProps = {
        width: '60',
        height: '60'
    };

    var ExistingMerchantIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { d: 'M0-38.1h82.173v82.173H0z', transform: 'translate(0 38.1)' }))),
            React__default["default"].createElement("g", { "clip-path": 'url(#a)' },
                React__default["default"].createElement("path", { d: 'M53.261 56.36v-7.516a.761.761 0 00-1.522 0v5.326c-1.469 0-3.043-2.679-3.043-4.565V41.83c6.674 2.5 9.13 8.014 9.13 12.34 0 1.109-1.576 1.859-4.565 2.19m-12.929 2.375c-4.892 0-10.254-.624-11.419-1.815v-1.229c3.072 0 4.565-1.991 4.565-6.087h13.7c0 2.452 1.917 6.087 4.565 6.087v1.017c-.026.027-.06.044-.081.076-.915 1.34-6.512 1.95-11.326 1.95M22.821 54.17c0-4.326 2.456-9.839 9.13-12.337v7.771c0 4.212-1.571 4.565-3.043 4.565v-5.325a.761.761 0 00-.761-.761.761.761 0 00-.761.761v7.532c-3.018-.313-4.565-1.05-4.565-2.206m12.922-8.048a.755.755 0 00.583.489.746.746 0 00.717-.259l3.292-3.941 3.409 3.95a.759.759 0 00.576.264.789.789 0 00.145-.014.763.763 0 00.575-.5l1.666-4.9c.158.04.313.083.467.126v6.745h-13.7v-6.741c.162-.046.326-.089.492-.132zm-.422-6.871l3.838 2.193-2.438 2.915-1.66-4.6zm5-.3a5.643 5.643 0 003.837-1.742 5.724 5.724 0 00.161.871l-3.998 2.279-3.982-2.278a5.869 5.869 0 00.155-.87 5.642 5.642 0 003.827 1.741m-5.734-7.524a4.113 4.113 0 01-1.109-2.367c0-1.3.236-1.522.761-1.522a11.014 11.014 0 007.421-3.254c.747 1.268 2.306 3.254 4.752 3.254.526 0 .761.22.761 1.522a4.1 4.1 0 01-1.107 2.365.762.762 0 00-.369.425c-1.186 3.337-3.343 5.58-5.376 5.58s-4.181-2.243-5.365-5.58a.762.762 0 00-.369-.423m5.734-12.258c5.2 0 6.491 4.13 6.773 6.944a2.582 2.582 0 00-.686-.1c-2.485 0-3.846-3.294-3.859-3.327a.761.761 0 00-.6-.468.755.755 0 00-.7.276c-.027.036-2.863 3.519-7.014 3.519a2.572 2.572 0 00-.686.1c.286-2.817 1.582-6.944 6.772-6.944m5.014 20.082l.256.515-1.563 4.593-2.522-2.922zm1.825.507a.741.741 0 00-.065-.384l-.755-1.522a.636.636 0 00-.606-.4 3.96 3.96 0 01-.082-.78v-1.291a14.194 14.194 0 001.405-2.82 5.54 5.54 0 001.638-3.5 5.694 5.694 0 00-.112-1.147.744.744 0 00.112-.374c0-6.195-3.129-9.891-8.37-9.891s-8.37 3.7-8.37 9.891a.744.744 0 00.112.374 5.694 5.694 0 00-.112 1.147 5.541 5.541 0 001.639 3.5 14.152 14.152 0 001.4 2.82v1.288a4.119 4.119 0 01-.078.78.821.821 0 00-.143.014.762.762 0 00-.46.388l-.761 1.522a.749.749 0 00-.065.39c-8.966 2.301-12.183 9.133-12.183 14.406 0 3.125 4.551 3.63 6.481 3.779 2.055 2.075 9.384 2.308 12.547 2.308 3.1 0 10.285-.233 12.328-2.308 1.983-.152 6.687-.664 6.687-3.779 0-5.267-3.218-12.111-12.188-14.41', fill: '#5fc5bf' }))));
    };
    ExistingMerchantIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ExistingMerchantIcon.defaultProps = {
        width: '150',
        height: '150'
    };

    var ExpandIcon = function (props) {
        var width = props.width, height = props.height, color = props.color;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M6 6.694a.693.693 0 01-.492-.2l-5.3-5.3a.695.695 0 01.983-.983L6 5.017 10.814.204a.695.695 0 01.983.983l-5.305 5.3A.692.692 0 016 6.694z', fill: color })));
    };
    ExpandIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string,
        color: PropTypes__default["default"].string
    };
    ExpandIcon.defaultProps = {
        width: '12',
        height: '6.695',
        color: '#C3C3C3'
    };

    var FilterIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { d: 'M5.549 10.737a4.72 4.72 0 01-1.186-3.435c0-1.816-.358-2.522-2.182-4.3A10.932 10.932 0 01-.001.437c0-.239 2.7-.435 6-.435s6 .2 6 .435a10.933 10.933 0 01-2.182 2.565C7.732 5.039 7.632 5.276 7.632 8.565c0 1.889-.2 3.435-.45 3.435a4.427 4.427 0 01-1.636-1.262z', fill: '#fff' })));
    };
    FilterIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    FilterIcon.defaultProps = {
        width: '12',
        height: '12'
    };

    var InstallationIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { d: 'M0-38.1h70.63v70.63H0z', transform: 'translate(0 38.1)' }))),
            React__default["default"].createElement("g", { "clip-path": 'url(#a)' },
                React__default["default"].createElement("path", { className: 'b', d: 'M54.086 22.663a6.484 6.484 0 00-1.776-2.587c-.8-.8-3.237-3.237-5.549-.925l-8.325 8.323a.654.654 0 00-.175.608 2.484 2.484 0 01-.75 2.167 2.479 2.479 0 01-2.184.746.646.646 0 00-.216 0 9.286 9.286 0 001.036 1.314 3.961 3.961 0 002.293-1.135 3.865 3.865 0 001.152-3.005l8.093-8.094c.833-.833 1.781-.993 3.7.925a5.416 5.416 0 011.448 2.038 1.528 1.528 0 01-.523 1.66l-8.094 8.1a3.88 3.88 0 00-3 1.156 3.964 3.964 0 00-1.137 2.305l1.241 1.239a.661.661 0 00.069-.443 2.487 2.487 0 01.746-2.184 2.494 2.494 0 012.157-.752.655.655 0 00.619-.173l8.323-8.321a2.831 2.831 0 00.851-2.962M24.101 49.209l-.925-.925 1.849-1.85.923.926zm2.774-2.774l-.927-.925 4.756-4.754-.925-.925-7.99 7.991a.653.653 0 000 .925l1.85 1.849a.654.654 0 00.925 0l7.99-7.99-.925-.925zM44.888 46.155a1.31 1.31 0 00-1.849 0 1.3 1.3 0 00-.379.924 1.3 1.3 0 00.383.925 1.3 1.3 0 00.917.384 1.3 1.3 0 00.925-.384 1.309 1.309 0 000-1.849', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M46.74 49.856a2.619 2.619 0 01-3.7 0L31.016 37.832a11.958 11.958 0 00-5.3-3.053 12.539 12.539 0 003.452-2.5 12.524 12.524 0 002.494-3.447 11.976 11.976 0 003.054 5.3L46.74 46.156a2.617 2.617 0 010 3.7M15.387 25.902l3.144 3.144a2.865 2.865 0 002.891.528 7.307 7.307 0 003.121-1.915 7.289 7.289 0 001.915-3.121 2.866 2.866 0 00-.528-2.891l-3.144-3.144c1.653-.683 4.622.923 6.844 3.144a5.13 5.13 0 011.554 3.447c0 .118-.009.316 0 .576-.008.152-.016.3-.037.458a9.411 9.411 0 01-2.9 5.231 9.1 9.1 0 01-5.594 2.943c-.458-.015-.755 0-.8 0h-.005a5.167 5.167 0 01-3.314-1.562c-2.221-2.221-3.828-5.193-3.144-6.843m20.25 7.311a11.37 11.37 0 01-3.146-7.563c.008-.179 0-.356 0-.532v-.053a.4.4 0 00-.005-.041 6.385 6.385 0 00-1.935-4.3c-2.9-2.9-7.026-5-9.249-2.775a.655.655 0 00-.192.462.655.655 0 00.192.462l3.7 3.7a1.674 1.674 0 01.192 1.621 6.081 6.081 0 01-1.581 2.543c-1.634 1.637-3.5 2.046-4.16 1.389l-3.7-3.7a.655.655 0 00-.925 0c-2.224 2.224-.121 6.353 2.775 9.249a6.386 6.386 0 004.33 1.94h.016c.089 0 .177.012.267.012s.164-.014.246-.016a11.4 11.4 0 017.627 3.15l12.024 12.025a3.924 3.924 0 005.548-5.549z', fill: '#6DC7BE' }))));
    };
    InstallationIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    InstallationIcon.defaultProps = {
        width: '150',
        height: '150'
    };

    var LogoMonerisMerchant = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 141.4 46.6', fill: '#fff', width: width, height: height },
            React__default["default"].createElement("path", { className: 'logo', d: 'M121.8 8.6c-.8-.7-1.7-1.3-2.7-1.7-1.1-.4-2.2-.7-3.3-.9-1.2-.2-2.4-.2-3.6-.1-1.3.1-2.6.4-3.8.9-1 .4-2 .9-2.9 1.5-1 .6-1.9 1.3-2.8 2.1-.9.8-1.7 1.8-2.5 2.8-.8 1.1-1.5 2.3-2 3.6-.6 1.4-1 2.8-1.3 4.2-.3 1.5-.4 3.1-.3 4.6.1 1.6.4 3.2.9 4.8.5 1.6 1.3 3.1 2.2 4.6 2.5 3.7 5.8 6.4 9.5 8 3.6 1.5 7.3 1.9 10.9 1.3 3.3-.5 6.3-1.9 8.8-4 2.2-1.8 4.1-4.1 5.3-6.8.1-.2.1-.4.1-.5v-.6c0-.2-.1-.4-.2-.6-.1-.2-.2-.4-.3-.5-.1-.1-.3-.3-.4-.3-.1-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1l-.3.3c-1.2 2.2-2.8 4-4.8 5.4-2.1 1.5-4.7 2.5-7.4 2.8-2.9.3-5.9-.2-8.8-1.5-3-1.3-5.6-3.5-7.6-6.4-.8-1.1-1.4-2.3-1.8-3.5-.4-1.2-.7-2.4-.9-3.7-.1-1.2-.1-2.4 0-3.6.1-1.2.4-2.3.8-3.4.3-.7.6-1.4.9-2 .3-.6.7-1.2 1.1-1.8.4-.5.8-1 1.3-1.5.4-.5.9-.9 1.4-1.3.3-.2.5-.4.8-.6.3-.2.5-.4.8-.5.3-.2.5-.3.8-.5.3-.1.5-.3.8-.4.3-.1.6-.3.9-.4l.9-.3c.3-.1.6-.1.9-.2.3 0 .6-.1.9-.1-.3.1-.5.2-.8.3-.3.1-.5.2-.8.4-.3.1-.5.3-.8.5-.2.2-.5.4-.7.6-.2.1-.3.3-.5.4-.2.2-.3.3-.4.5-.1.2-.3.3-.4.5-.1.2-.3.4-.4.6-1 1.5-1.6 3.3-1.8 5.2-.2 2 0 4 .7 6 .7 2.1 1.9 4 3.4 5.6 1.6 1.6 3.5 2.8 5.6 3.5 1.2.4 2.5.6 3.7.7 1.2.1 2.4 0 3.5-.2s2.1-.6 3-1c.9-.4 1.8-1 2.5-1.7.7-.6 1.4-1.3 1.9-2.1.5-.7 1-1.5 1.3-2.3.3-.8.6-1.6.8-2.4.2-.8.3-1.7.3-2.5.1-2-.2-4-.8-5.9-.5-1.7-1.3-3.4-2.2-4.9-.9-1.5-2-2.8-3.3-4.1-1.3-1.2-2.7-2.3-4.4-3.3.4-.2.3-.2.2-.3h-.3c-.1 0-.2 0-.2.1-.1 0-.1.1-.2.2v.3c0 .1 0 .2.1.3.1.1.1.2.2.3.1.1.2.2.3.2 1.5.8 2.8 1.8 3.9 2.9 1.1 1.1 2.1 2.4 2.9 3.7.8 1.4 1.5 2.9 1.9 4.4.4 1.6.6 3.4.5 5.2l-.3 2.1c-.2.7-.4 1.4-.7 2-.3.7-.7 1.3-1.2 1.8-.5.6-1 1.1-1.7 1.6s-1.4.9-2.1 1.2c-.8.3-1.6.6-2.5.7-.9.1-1.8.1-2.8 0-1-.1-2-.3-2.9-.7-.4-.1-.8-.3-1.1-.5-.4-.2-.7-.4-1.1-.6-.3-.2-.7-.5-1-.7-.3-.3-.6-.5-.9-.8.6.3 1.2.5 1.9.7.6.2 1.3.3 1.9.4.6.1 1.3.1 1.9 0 .6 0 1.2-.1 1.8-.3.9-.2 1.7-.6 2.4-1s1.4-.8 2-1.4c.6-.5 1.1-1.1 1.5-1.7.4-.6.8-1.2 1.1-1.9.3-.7.5-1.3.6-2 .1-.7.2-1.3.2-2s0-1.3-.1-2c-.1-.6-.3-1.3-.5-1.9-.5-1.6-1.3-3-2.2-4.2-.9-1.2-2-2.4-3.2-3.3-1.2-1-2.6-1.8-4.1-2.5-1.5-.7-3.2-1.2-5-1.4-2.4-.3-4.7-.3-7.1 0-2.6.4-5.1 1.2-7.5 2.4-2.7 1.4-5.2 3.3-7.3 5.7-2.4 2.7-4.2 6.1-5.1 9.9-.1.3 0 .5 0 .7.1.2.2.4.5.6.2.2.5.3.8.3.3.1.7.1 1 0 .4 0 .7-.1 1.1-.3.3-.1.6-.3.9-.5.3-.2.5-.4.6-.6.2-.2.3-.5.3-.7.5-3.2 1.8-6 3.6-8.3 1.6-2.1 3.6-3.8 5.8-5.1 2-1.2 4.1-1.9 6.3-2.4 2-.4 4.1-.5 6.2-.2 1.6.2 3 .6 4.3 1.2 1.3.6 2.5 1.3 3.6 2.1s2 1.8 2.8 2.9c.8 1.1 1.4 2.4 1.9 3.7.2.5.3 1.1.4 1.6.1.5.1 1.1.1 1.6s-.1 1.1-.2 1.6-.3 1.1-.6 1.6l-.9 1.5c-.4.5-.8.9-1.3 1.2-.5.4-1 .7-1.6 1-.6.3-1.2.5-1.9.6-.5.1-1.1.2-1.7.2-.6 0-1.1-.1-1.7-.2-.6-.1-1.1-.3-1.7-.6-.6-.3-1.1-.6-1.6-1s-1-.8-1.4-1.3c-.4-.5-.8-1-1.1-1.5-.3-.5-.5-1.1-.7-1.6-.2-.6-.2-1.4-.2-2 0-.3.2-1 .3-1.3.1-.3.2-.5.3-.8.1-.2.2-.5.4-.7.5-.9 1.2-1.7 2-2.2.8-.5 1.6-.9 2.5-1.1.9-.2 1.8-.2 2.7-.1.8.1 1.6.4 2.3.8.1.1.2.1.4.1h.3c.1 0 .2-.1.3-.1.1-.1.2-.1.2-.2s.1-.2.1-.3V9c0-.1-.1-.2-.2-.3-.1.1-.2 0-.3-.1zM18.5 43.1l-1.1-7.6c-.2-1.5-.4-2.7-.5-3.8-.2 1-.5 2.1-.9 3.4l-2.5 8h-3L8 35.8c-.4-1.3-.8-2.7-1-4-.1 1.4-.3 2.7-.4 4l-.9 7.3H2.5l2.4-15.9h3.6l2.7 8.2c.4 1.1.7 2.2.9 3.3.2-1.2.5-2.1.9-3.3l2.7-8.2h3.6l2.5 15.9h-3.3zM32.1 37.2c0 2.4-1.1 3.6-2.6 3.6-1.7 0-2.6-1.2-2.6-3.6 0-2.4 1.3-3.4 2.7-3.4 1.7 0 2.5 1.2 2.5 3.4zm3.1-.1c0-4-2.1-5.9-5.5-5.9-3.6 0-6 2.6-6 6.3 0 4.2 2.1 5.9 5.5 5.9 3.5 0 6-2.7 6-6.3zM59 35.7h-4.3c.2-1.4 1-2.3 2.3-2.3 1.3 0 2.1.9 2 2.3zm3 .7c0-2.9-1.5-5.2-4.9-5.2-3.5 0-5.5 2.6-5.5 6.2 0 4.1 2.1 6 5.8 6 1.5 0 2.9-.3 4.2-.8l-.3-2.3c-1 .5-2.3.7-3.4.7-2.2 0-3.2-1.1-3.2-3.2h7.2c.1-.5.1-1 .1-1.4zM64.5 33.6c-.2-.3-.3-.6-.3-1s.1-.7.3-1c1.4-.2 3.1-.2 4.6-.2 0 .6-.1 1.6-.2 2.4.6-1.5 1.7-2.8 3.7-2.6l-.1 3c-2.2-.4-3.2 1-3.2 4.2v4.8h-3v-9.4c-.5-.1-1.2-.2-1.8-.2zM80 28.1c0-1-.8-1.8-1.9-1.8-1 0-1.9.8-1.9 1.8s.8 1.8 1.9 1.8c1 .1 1.9-.8 1.9-1.8zM85.5 43.4c-.8 0-1.7-.1-2.4-.2l.1-2.5c.7.2 1.6.4 2.5.4 1.2 0 1.9-.5 1.9-1.2 0-2.1-4.7-.9-4.7-4.9 0-2 1.7-3.7 5-3.7.7 0 1.4.1 2.1.2l-.1 2.4c-.7-.2-1.4-.3-2.2-.3-1.2 0-1.7.5-1.7 1.2 0 1.9 4.8 1.1 4.8 4.8-.1 2.2-2.1 3.8-5.3 3.8zM41.4 31.4c0 .6 0 1.5-.2 2.1.7-1.4 2.1-2.4 4-2.4 2.6 0 3.5 1.7 3.5 3.7V43h-3v-7.5c0-1.2-.3-2-1.4-2-1.5 0-2.7 1.7-2.7 3.8v5.6h-3v-9.4c-.5-.1-1.1-.2-1.8-.2-.2-.3-.3-.6-.3-1s.1-.7.3-1c1.4.2 3.1.1 4.6.1zM79.6 31.4c-1.5 0-3.3 0-4.7.2-.2.3-.3.6-.3 1s.1.7.3 1c.6.1 1.3.1 1.8.2v9.4h3V31.4z' }),
            React__default["default"].createElement("g", null,
                React__default["default"].createElement("path", { className: 'logo', d: 'M138.8 3.3v-1l-.3.9-.4 1.1h-.3l-.3-1.1c-.1-.3-.2-.7-.2-1v1.1l-.1 1h-.4l.2-2.5h.6l.3 1c.1.3.2.6.2.9.1-.3.2-.6.2-.9l.3-1h.6l.1 2.5h-.4l-.1-1zM139.8 1.9c.2 0 .5-.1.7-.1.5 0 .8.1 1 .3.2.2.4.5.4.9s-.2.8-.4 1c-.2.2-.6.3-1.1.3h-.6V1.9zm.4 2.1h.3c.6 0 .9-.3.9-.9 0-.5-.3-.9-.9-.9h-.3V4z' })),
            React__default["default"].createElement("path", { className: 'logo', d: 'M134.5 3.1c0 1-.7 1.7-1.7 1.7s-1.7-.7-1.7-1.7c0-.9.8-1.7 1.7-1.7 1 0 1.7.7 1.7 1.7zm-3 0c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.5-1.3-1.3-1.3-.7-.1-1.3.5-1.3 1.3zm1.1.8h-.4V2.3c.2 0 .4-.1.6-.1.3 0 .5.1.6.1.1.1.2.2.2.4s-.1.3-.3.4c.2.1.3.2.3.4.1.3.1.4.1.4h-.4c-.1-.1-.1-.2-.1-.4s-.1-.3-.3-.3h-.2v.7zm0-.9h.2c.2 0 .4-.1.4-.2 0-.2-.1-.3-.4-.3h-.2V3z' }),
            React__default["default"].createElement("g", null,
                React__default["default"].createElement("path", { className: 'logo', d: 'M136.4 1.6l-1.2 3h-.5l1.2-3h.5z' }))));
    };
    LogoMonerisMerchant.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    LogoMonerisMerchant.defaultProps = {
        width: '48',
        height: '48'
    };

    var NewMerchantIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { d: 'M0-38.1h82.173v82.173H0z', transform: 'translate(0 38.1)' }))),
            React__default["default"].createElement("g", { "clip-path": 'url(#a)' },
                React__default["default"].createElement("path", { className: 'b', d: 'M64.297 48.431h-5.6v-5.628a.759.759 0 00-.757-.761.759.759 0 00-.76.761v5.63h-5.6a.758.758 0 00-.757.761.758.758 0 00.757.761h5.6v5.63a.758.758 0 101.515 0v-5.633h5.6a.761.761 0 000-1.522M27.734 55.754h-.757a.761.761 0 010-1.522h.757c1.465 0 3.027-.353 3.027-4.565v-9.23a.76.76 0 01.761-.761.759.759 0 01.757.761v9.23c0 4.1-1.485 6.087-4.542 6.087M48.173 55.754h-.757c-2.635 0-4.542-3.635-4.542-6.087v-9.23a.758.758 0 01.757-.761.759.759 0 01.757.761v9.23c0 1.887 1.567 4.564 3.028 4.564h.757a.761.761 0 010 1.522', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M43.629 49.667h-12.11a.759.759 0 01-.757-.761.759.759 0 01.757-.761h12.11a.759.759 0 01.76.761.759.759 0 01-.76.761M31.867 31.491a.76.76 0 01.367.424c1.182 3.334 3.333 5.58 5.347 5.58s4.165-2.244 5.343-5.58a.761.761 0 01.368-.425 4.117 4.117 0 001.1-2.365c0-1.3-.234-1.522-.757-1.522-2.434 0-3.985-1.987-4.728-3.256a10.934 10.934 0 01-7.382 3.257c-.524 0-.758.219-.758 1.522a4.125 4.125 0 001.1 2.365m5.71 7.526c-2.652 0-5.265-2.5-6.7-6.391a5.546 5.546 0 01-1.631-3.5c0-2.021.764-3.043 2.271-3.043 4.131 0 6.952-3.484 6.98-3.519a.746.746 0 01.7-.278.758.758 0 01.593.469c.013.033 1.367 3.327 3.84 3.327 1.507 0 2.27 1.023 2.27 3.043a5.549 5.549 0 01-1.63 3.5c-1.433 3.891-4.046 6.391-6.7 6.391', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M33.096 40.878a.752.752 0 01-.623-.329.762.762 0 01.193-1.058 3.174 3.174 0 001.124-2.536.758.758 0 01.756-.761.758.758 0 01.757.761 4.688 4.688 0 01-1.778 3.788.751.751 0 01-.429.135M42.114 40.877a.748.748 0 01-.427-.134 4.693 4.693 0 01-1.777-3.788.759.759 0 01.757-.761.759.759 0 01.757.761 3.176 3.176 0 001.13 2.541.765.765 0 01.178 1.057.75.75 0 01-.619.324', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M52.265 47.163a.754.754 0 01-.65-.372c-1.88-3.178-5.116-5.168-9.623-5.912a.76.76 0 01-.624-.874.75.75 0 01.87-.626c4.968.82 8.561 3.054 10.677 6.634a.762.762 0 01-.263 1.042.746.746 0 01-.387.107M37.581 60.319c-2.716 0-9.026-.233-10.984-2.308-1.921-.148-6.435-.657-6.435-3.778 0-3.839 1.249-12.972 12.811-14.867a.757.757 0 01.87.628.764.764 0 01-.625.875c-10.041 1.645-11.54 9.078-11.54 13.364 0 1.258 1.8 2.028 5.353 2.285a.758.758 0 01.571.331c.91 1.339 5.81 1.949 9.979 1.949s9.057-.61 9.967-1.949a.754.754 0 011.052-.2.762.762 0 01.2 1.058c-1.6 2.359-8.378 2.614-11.217 2.614', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M26.976 58.037a.758.758 0 01-.757-.761v-9.891a.758.758 0 01.757-.761.759.759 0 01.757.761v9.891a.759.759 0 01-.757.761M48.174 58.037a.758.758 0 01-.757-.761v-9.891a.758.758 0 01.757-.761.759.759 0 01.757.761v9.891a.759.759 0 01-.757.761M48.181 42.82a.758.758 0 01-.7-.479 43.83 43.83 0 01-3.087-14.739c0-2.517-.663-8.37-6.813-8.37s-6.814 5.853-6.814 8.37a43.83 43.83 0 01-3.082 14.739.754.754 0 01-.984.425.763.763 0 01-.422-.989 43.132 43.132 0 002.974-14.175c0-6.194 3.113-9.891 8.328-9.891s8.324 3.697 8.324 9.891a43.109 43.109 0 002.974 14.174.762.762 0 01-.422.989.736.736 0 01-.281.054', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M37.576 46.626a.711.711 0 01-.126-.011 6.35 6.35 0 01-5.175-6.5.759.759 0 01.758-.759.759.759 0 01.757.761 4.821 4.821 0 003.91 5 .761.761 0 01-.124 1.509', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M37.574 46.626a.761.761 0 01-.125-1.513 4.857 4.857 0 003.912-5 .759.759 0 01.757-.761.759.759 0 01.757.761 6.35 6.35 0 01-5.175 6.5.711.711 0 01-.126.013M47.892 57.73c1.972-.153 6.653-.664 6.653-3.779a13.465 13.465 0 00-.17-2.108.756.756 0 00-.868-.629.758.758 0 00-.627.871 11.951 11.951 0 01.152 1.867c0 1.11-1.569 1.859-4.54 2.189', fill: '#6DC7BE' }))));
    };
    NewMerchantIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    NewMerchantIcon.defaultProps = {
        width: '150',
        height: '150'
    };

    var PasswordShowIcon = function (props) {
        var active = props.active;
        var color = active ? '#051d33' : '#c3c3c3';
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '20', height: '10', viewBox: '0 0 24.41 12.608' },
            React__default["default"].createElement("g", { transform: 'translate(-69.535 -142.91)', stroke: color },
                React__default["default"].createElement("path", { d: 'M70.55 150.484c4.413-9.022 18.175-8.47 22.38.037', fill: 'none', strokeWidth: '2.018', strokeLinecap: 'round', strokeLinejoin: 'bevel' }),
                React__default["default"].createElement("ellipse", { cx: '81.63', cy: '150.598', rx: '4.364', ry: '4.458', fill: color, strokeWidth: '.922' }))));
    };
    PasswordShowIcon.propTypes = {
        active: PropTypes__default["default"].bool
    };
    PasswordShowIcon.defaultProps = {
        active: true
    };

    var PlusIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("g", { transform: 'translate(0 2)', fill: '#fff', stroke: '#051D33' },
                React__default["default"].createElement("circle", { cx: '9.5', cy: '9.5', r: '9.5', stroke: 'none' }),
                React__default["default"].createElement("circle", { cx: '9.5', cy: '9.5', r: '9', fill: 'none' })),
            React__default["default"].createElement("text", { transform: 'translate(4 17)', fill: '#051D33', fontSize: '18', fontFamily: 'AvenirLTStd-Heavy,Avenir LT Std', fontWeight: '800' },
                React__default["default"].createElement("tspan", { x: '0', y: '0' }, "+"))));
    };
    PlusIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    PlusIcon.defaultProps = {
        width: '19',
        height: '22'
    };

    var ProcessingIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("clipPath", { id: 'a' },
                    React__default["default"].createElement("path", { d: 'M0-38.1h75.212v75.211H0z', transform: 'translate(0 38.1)' }))),
            React__default["default"].createElement("g", { "clip-path": 'url(#a)' },
                React__default["default"].createElement("path", { className: 'b', d: 'M26.817 29.585h14.512v-9.312H26.817zm15.171 1.33H26.157a.66.66 0 01-.658-.664V19.607a.661.661 0 01.658-.665h15.831a.662.662 0 01.66.665v10.64a.662.662 0 01-.66.664M38.691 34.911h1.32v-1.33h-1.32zm1.979 1.331h-2.64a.664.664 0 01-.659-.666v-2.665a.662.662 0 01.659-.664h2.64a.661.661 0 01.659.664v2.661a.662.662 0 01-.659.666M33.412 34.911h1.324v-1.33h-1.32zm1.981 1.331h-2.639a.663.663 0 01-.659-.666v-2.665a.661.661 0 01.659-.664h2.639a.661.661 0 01.659.664v2.661a.662.662 0 01-.659.666M28.132 34.911h1.319v-1.33h-1.319zm1.978 1.331h-2.634a.663.663 0 01-.659-.666v-2.665a.661.661 0 01.659-.664h2.638a.661.661 0 01.66.664v2.661a.662.662 0 01-.66.666M38.691 40.228h1.32v-1.33h-1.32zm1.979 1.33h-2.64a.662.662 0 01-.659-.665v-2.656a.663.663 0 01.659-.665h2.64a.662.662 0 01.659.665v2.661a.661.661 0 01-.659.665M33.412 40.228h1.324v-1.33h-1.32zm1.981 1.33h-2.639a.662.662 0 01-.659-.665v-2.656a.662.662 0 01.659-.665h2.639a.662.662 0 01.659.665v2.661a.661.661 0 01-.659.665M38.691 45.549h1.32v-1.33h-1.32zm1.979 1.332h-2.64a.663.663 0 01-.659-.666v-2.66a.663.663 0 01.659-.665h2.64a.662.662 0 01.659.665v2.66a.662.662 0 01-.659.666M33.412 45.549h1.324v-1.33h-1.32zm1.981 1.332h-2.639a.662.662 0 01-.659-.666v-2.66a.662.662 0 01.659-.665h2.639a.662.662 0 01.659.665v2.66a.662.662 0 01-.659.666M28.132 40.228h1.319v-1.33h-1.319zm1.978 1.33h-2.634a.662.662 0 01-.659-.665v-2.656a.662.662 0 01.659-.665h2.638a.662.662 0 01.66.665v2.661a.661.661 0 01-.66.665M28.132 45.549h1.319v-1.33h-1.319zm1.978 1.332h-2.634a.662.662 0 01-.659-.666v-2.66a.662.662 0 01.659-.665h2.638a.662.662 0 01.66.665v2.66a.662.662 0 01-.66.666', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M44.998 48.754a2.64 2.64 0 01-2.35 1.453H25.499a2.653 2.653 0 01-2.64-2.66v-28.6a2.653 2.653 0 012.64-2.662H40.01a.663.663 0 01.659.666.663.663 0 01-.659.665H25.499a1.326 1.326 0 00-1.32 1.331v28.6a1.327 1.327 0 001.32 1.33h17.149a1.32 1.32 0 001.17-.715l.109-.194z', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M45.286 33.244v-14.3a2.653 2.653 0 00-2.638-2.663h-3.3a.661.661 0 00-.66.666.661.661 0 00.66.664h3.3a1.327 1.327 0 011.32 1.332v13.65a2.2 2.2 0 011.318.65M39.746 56.674H28.28a1.93 1.93 0 01-1.92-1.939v-5.061a.694.694 0 01.692-.7.7.7 0 01.693.7v5.061a.538.538 0 00.536.54h11.465a.539.539 0 00.537-.54v-5.061a.694.694 0 01.692-.7.694.694 0 01.692.7v5.061a1.931 1.931 0 01-1.921 1.939', fill: '#6DC7BE' }),
                React__default["default"].createElement("path", { className: 'b', d: 'M31.967 53.624a.694.694 0 01-.692-.7v-2.476a.694.694 0 01.692-.7.7.7 0 01.692.7v2.478a.7.7 0 01-.692.7M56.277 44.914a2.48 2.48 0 01-1.33 3.216l-3.73 1.543a2.39 2.39 0 01-2.371-.315l-5.571-4.116a.613.613 0 01-.047-.846.6.6 0 01.412-.2.71.71 0 01.454.144c.013.029.041.016.053.045l2.106 1.524c.01.029.039.017.052.046l.039.017a.111.111 0 00.068 0l.04.017c.029-.013.039.016.068.006s.04.016.069 0 .028-.012.068 0c.029-.012.029-.012.068.006a.514.514 0 00.057-.023l.056-.024.029-.011.056-.023c.029-.013.029-.013.046-.052.029-.013.029-.013.044-.053.028-.011.017-.04.047-.052a.028.028 0 00.015-.039c.028-.013.017-.041.045-.052l.016-.041.017-.041c-.012-.029.017-.038 0-.068a.109.109 0 00.006-.07c-.012-.027.016-.04 0-.068s-.012-.029 0-.068c-.011-.029-.011-.029.006-.07l-.023-.057-.013-.047-4.1-10.051a.619.619 0 01.332-.8.611.611 0 01.8.335l2.556 6.264a.609.609 0 00.8.336.621.621 0 00.333-.8l-.7-1.708a.618.618 0 01.334-.8.61.61 0 01.8.334l.922 2.27a.609.609 0 00.8.336.619.619 0 00.334-.8l-.701-1.716a.62.62 0 01.333-.8.611.611 0 01.8.336l.925 2.278a.609.609 0 00.8.334.619.619 0 00.333-.8l-.467-1.14a.619.619 0 01.331-.808.613.613 0 01.8.336l1.854 4.558.7 1.708zm-4.046-8.307a2.369 2.369 0 00-.575.371 1.832 1.832 0 00-2.149-.574 1.666 1.666 0 00-.725.567 1.848 1.848 0 00-1.765-.2 1.387 1.387 0 00-.518.348l-1.207-2.96a1.833 1.833 0 00-2.39-1.007 1.859 1.859 0 00-1 2.412l3.3 8.086-.336-.26a1.743 1.743 0 00-1.3-.428 1.872 1.872 0 00-1.264.623 1.888 1.888 0 00.178 2.622.031.031 0 00.039.018l5.583 4.142a3.662 3.662 0 003.582.446l3.727-1.545a3.715 3.715 0 002-4.821l-.233-.568-.7-1.71-1.861-4.556a1.83 1.83 0 00-2.386-1.006', fill: '#6DC7BE' }))));
    };
    ProcessingIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    ProcessingIcon.defaultProps = {
        width: '150',
        height: '150'
    };

    var SortIcon = function (props) {
        var width = props.width, height = props.height;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height },
            React__default["default"].createElement("path", { style: { fill: '#00677f' }, d: 'M.575 5.303a.335.335 0 00-.238-.1.335.335 0 00-.235.1.336.336 0 000 .477l2.7 2.7a.333.333 0 00.109.073.336.336 0 00.258 0 .329.329 0 00.109-.073l2.7-2.7a.34.34 0 00-.484-.477L3.372 7.424 3.44.337a.337.337 0 00-.338-.336.336.336 0 00-.337.337l-.063 7.086zM11.494 3.274a.335.335 0 00.238.1.335.335 0 00.235-.1.336.336 0 000-.477l-2.7-2.7a.333.333 0 00-.109-.073.336.336 0 00-.258 0 .329.329 0 00-.109.073l-2.7 2.7a.34.34 0 00.484.477l2.122-2.121-.068 7.087a.337.337 0 00.338.336.336.336 0 00.337-.337l.063-7.086z' })));
    };
    SortIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    SortIcon.defaultProps = {
        width: '12.069',
        height: '8.575'
    };

    var SwirlIcon = function (props) {
        //   const { width, height } = props;
        return (React__default["default"].createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 550 570' },
            React__default["default"].createElement("defs", null,
                React__default["default"].createElement("linearGradient", { id: 'a', x1: '0%', y1: '100%', x2: '100%', y2: '0%' },
                    React__default["default"].createElement("stop", { offset: '0%', "stop-color": '#eee', "stop-opacity": '.6' }),
                    React__default["default"].createElement("stop", { offset: '100%', "stop-color": '#eee' }))),
            React__default["default"].createElement("path", { fill: 'url(#a)', d: 'M396.1 121.1c-8.7-7-17.8-13.5-28.4-17.6-11.3-4.3-22.9-7.9-34.9-9.7-12.4-1.9-25.1-2.4-37.9-1.2-13.3 1.3-26.8 4.3-40.1 9.4-10.7 4.1-20.9 9.2-30.7 15.2-10.3 6.3-20 13.6-29 22-9.5 8.7-18.3 18.6-26.1 29.5-8.2 11.4-15.4 24-21.3 37.6-6.2 14.2-10.7 29.1-13.6 44.5-2.9 16-4 32.3-3 48.6 1 16.9 4.1 33.7 9.5 50 5.5 16.7 13.1 32.7 23 47.7 25.7 38.7 60.3 66.9 99.2 83.5 37.5 16 77 20.2 114.3 14 34.4-5.7 65.7-20.1 91.9-41.4 23.6-19.1 42.5-43.4 55.9-71.5.8-1.7 1.3-3.7 1.6-5.7.2-2 .1-4.2-.2-6.3-.3-2.1-.9-4.2-1.7-6.2-.8-2-1.9-3.8-3.2-5.4-1.3-1.6-2.7-2.7-4.1-3.5-1.4-.8-2.9-1.2-4.2-1.2-1.4 0-2.7.4-4 1.2-1.2.8-2.3 2-3.2 3.6-12.4 22.9-29.4 42-49.9 56.6-22.4 15.9-48.8 26-77.1 29.1-30.3 3.3-62-1.6-92-15.3-30.9-14.1-58.6-36.8-79.8-67.5-7.9-11.5-14.2-23.7-18.9-36.5-4.6-12.6-7.6-25.5-9-38.6-1.4-12.8-1.3-25.6.3-38.2 1.5-12.2 4.4-24.2 8.7-35.8 2.7-7.4 5.8-14.4 9.4-21.1 3.5-6.5 7.4-12.7 11.6-18.5 4.1-5.7 8.6-11 13.3-16 4.6-4.8 9.5-9.3 14.7-13.4 2.6-2.1 5.3-4.1 8.1-6.1 2.7-1.9 5.5-3.7 8.3-5.4 2.8-1.7 5.6-3.3 8.5-4.8 2.9-1.5 5.7-2.9 8.7-4.2 3.3-1.4 6.6-2.7 9.9-3.8 3.3-1.1 6.6-2 9.9-2.8 3.3-.8 6.6-1.4 9.9-1.9 3.3-.5 6.5-.8 9.8-1.1-2.8 1-5.6 2.1-8.3 3.3-2.8 1.2-5.5 2.6-8.2 4.1-2.7 1.5-5.3 3.2-7.9 4.9-2.6 1.8-5.1 3.8-7.6 5.8-1.6 1.4-3.3 2.9-4.9 4.5-1.6 1.6-3.1 3.2-4.7 4.9-1.5 1.7-3 3.5-4.4 5.4-1.4 1.9-2.8 3.8-4.1 5.9-10.5 16.2-16.9 34.6-19.2 54.1-2.4 20.7 0 42.2 7.1 62.9 7.3 21.5 19.4 41.5 35.7 58.2 16.4 16.8 36.4 29.6 59 36.9 13.1 4.2 26.1 6.7 39 7.4 12.5.8 24.6 0 36.2-2.3 11.2-2.2 21.9-5.8 31.9-10.7 9.6-4.7 18.5-10.5 26.6-17.4 7.8-6.6 14.5-13.9 20.3-21.9 5.5-7.6 10.2-15.8 13.9-24.3 3.6-8.2 6.3-16.8 8.2-25.6 1.8-8.5 2.9-17.3 3.2-26.3.7-21.5-2.3-42.1-7.9-61.4-5.4-18.2-13.3-35.5-23.1-51.3-9.6-15.4-21.2-29.8-34.5-42.7C443.3 74.5 428 62.8 410.8 53c-1.1-.7-2.3-1.1-3.4-1.4-1.1-.3-2.2-.4-3.1-.3-1 .1-1.8.3-2.5.8-.7.4-1.3 1.1-1.6 1.9-.3.8-.4 1.7-.3 2.6.1.9.5 1.9 1.1 2.9.6 1 1.3 1.9 2.2 2.8.9.9 2 1.7 3.1 2.3 15.6 8.7 29.4 19.2 41.4 30.7 12 11.6 22.4 24.7 30.8 38.6 8.7 14.3 15.5 29.9 19.9 46.1 4.6 17.1 6.7 35.3 5.4 54.1-.5 7.5-1.7 14.8-3.5 21.8-1.9 7.3-4.5 14.3-7.8 20.9-3.4 6.8-7.6 13.3-12.4 19.3-5.1 6.2-10.9 11.8-17.6 16.8-6.9 5.1-14.3 9.4-22.3 12.7-8.2 3.4-16.9 5.8-26.1 7.2-9.4 1.3-19.1 1.5-29 .5-10.1-1-20.4-3.3-30.7-7-4.1-1.4-8-3.1-11.9-5-3.9-1.9-7.6-4-11.3-6.3-3.6-2.3-7.1-4.8-10.5-7.5-3.4-2.7-6.6-5.5-9.6-8.6 6.4 3.2 13 5.7 19.7 7.7 6.6 1.9 13.3 3.3 20 4 6.6.7 13.2.8 19.7.3 6.4-.5 12.7-1.6 18.9-3.2 9.2-2.4 17.7-5.8 25.6-10 7.6-4.1 14.5-8.9 20.7-14.3 6-5.3 11.3-11.2 15.9-17.5 4.4-6.2 8.2-12.8 11.2-19.9 2.9-6.8 5.1-13.8 6.6-20.8 1.4-6.9 2.2-13.8 2.2-20.8.1-6.8-.4-13.7-1.5-20.5-1.1-6.7-2.8-13.4-5-20-5.5-16.3-13.4-31.2-23-44.5-9.5-13-20.8-24.8-33.4-35-12.7-10.2-27.1-19.1-42.6-26-16-7.1-33.6-12.4-52.4-15.2-24.6-3.6-49.5-3.4-73.9.3-26.6 4-53.1 12.5-78.2 25.5-27.9 14.4-54.1 34.4-76.1 59.7-24.7 28.5-43.8 63.6-53.2 104.1-.7 2.8-.5 5.4.5 7.7.9 2.3 2.6 4.3 4.8 5.9 2.2 1.6 5 2.8 8.3 3.4 3.2.7 6.9.8 10.8.4 3.9-.4 7.7-1.4 11.2-2.8 3.5-1.4 6.6-3.1 9.4-5.2 2.7-2 5-4.3 6.8-6.8 1.7-2.4 2.8-5 3.3-7.6 5.5-33.3 19.1-62.8 37.7-87.3 16.9-22.2 37.7-40 60.5-53.3 20.7-12.1 43.2-20.4 66.1-24.8 21.2-4.1 43-4.9 64.9-2.2 16.2 2 31.5 6.3 45.5 12.3 13.6 5.9 26.2 13.5 37.3 22.4 11.1 8.9 21 19.2 29.1 30.6 8.3 11.6 15 24.7 19.4 38.8 1.7 5.5 2.9 11 3.7 16.5.8 5.6 1 11.2.7 16.7-.3 5.6-1.1 11.2-2.5 16.7-1.4 5.6-3.4 11.1-6.1 16.4-2.7 5.5-5.9 10.6-9.7 15.3-3.9 4.8-8.3 9.2-13.3 13.1-5.1 4-10.7 7.4-16.9 10.3-6.3 2.9-13.1 5.2-20.3 6.7-5.7 1.2-11.6 1.8-17.5 1.7-6-.1-12-.8-18-2.2-6-1.4-12-3.4-17.8-6.1-5.8-2.7-11.4-6.1-16.7-10.1-5.3-4-10.3-8.5-14.7-13.4-4.4-4.9-8.3-10.2-11.5-15.7-3.2-5.5-5.7-11.3-7.4-17.2-1.7-5.9-2-14.9-1.8-20.9.1-3.4 1.7-10.7 2.7-13.4 1-2.7 2.2-5.3 3.4-7.9 1.2-2.5 2.5-4.9 3.8-7.2 5.5-9.7 12.8-17.4 21.2-23.3 8-5.6 17-9.5 26.5-11.6 9.1-2 18.5-2.5 28.1-1.1 8.7 1.2 16.7 4 24.1 8 1.3.7 2.5 1.2 3.8 1.5 1.2.3 2.5.3 3.6.1 1.1-.2 2.1-.5 3-1.1.9-.6 1.6-1.3 2.1-2.3.5-.9.8-2 .9-3.1 0-1.1-.1-2.2-.5-3.4-.4-1.2-.9-2.3-1.7-3.3-1-1-2-2-3-2.9z' })));
    };
    SwirlIcon.propTypes = {
        width: PropTypes__default["default"].string,
        height: PropTypes__default["default"].string
    };
    SwirlIcon.defaultProps = {
        width: '576',
        height: '576'
    };

    exports.ActiveExistingMerchantIcon = ActiveExistingMerchantIcon;
    exports.CheckIcon = CheckIcon;
    exports.ChevronCancel = ChevronCancel;
    exports.ChevronClose = ChevronClose;
    exports.ChevronCopyIcon = ChevronCopyIcon;
    exports.ChevronDown = ChevronDown;
    exports.ChevronExpired = ChevronExpired;
    exports.ChevronExpiredWarning = ChevronExpiredWarning;
    exports.ChevronInfo = ChevronInfo;
    exports.ChevronLeft = ChevronLeft;
    exports.ChevronLock = ChevronLock;
    exports.ChevronPlus = ChevronPlus;
    exports.ChevronRight = ChevronRight;
    exports.ChevronSearch = ChevronSearch;
    exports.ChevronUp = ChevronUp;
    exports.CollapseIcon = CollapseIcon;
    exports.CrossIcon = CrossIcon;
    exports.ErrorIcon = ErrorIcon;
    exports.ExistingMerchantIcon = ExistingMerchantIcon;
    exports.ExpandIcon = ExpandIcon;
    exports.FilterIcon = FilterIcon;
    exports.InstallationIcon = InstallationIcon;
    exports.LogoMonerisMerchant = LogoMonerisMerchant;
    exports.NewMerchantIcon = NewMerchantIcon;
    exports.PasswordShowIcon = PasswordShowIcon;
    exports.PlusIcon = PlusIcon;
    exports.ProcessingIcon = ProcessingIcon;
    exports.SortIcon = SortIcon;
    exports.SwirlIcon = SwirlIcon;

    Object.defineProperty(exports, '__esModule', { value: true });

  }));
  }(dist$2, dist$2.exports));

  /* eslint-disable */
  var ArrayParser = {
    getNextVal: function getNextVal(arrayObj, val) {
      var length = arrayObj.length;
      if (length === 0) {
        return 'undefined';
      } else {
        var index = 0;
        for (var i = 0; i < length; i++) {
          if (JSON.stringify(arrayObj[i]) === JSON.stringify(val)) index = i;
        }
        if (index !== length - 1) return arrayObj[index + 1];
      }
      return arrayObj[0];
    },
    getPrevVal: function getPrevVal(arrayObj, val) {
      var length = arrayObj.length;
      if (length === 0) {
        return 'undefined';
      } else {
        var index = 0;
        for (var i = 0; i < length; i++) {
          if (JSON.stringify(arrayObj[i]) === JSON.stringify(val)) index = i;
        }
        if (index !== 0) return arrayObj[index - 1];
      }
      return arrayObj[0];
    }
  };

  var css_248z$8 = "/* Consolidation of frequently used colours throughout the repo */\n.dropdown-seq {\n  display: flex;\n  position: relative;\n  border: 1px solid gray;\n  border-radius: 4px;\n  padding: 8.5px 6px;\n  align-items: center;\n  min-height: 28px;\n  color: #051d33;\n}\n.dropdown-seq:hover {\n  margin: 0;\n  border: 1px solid #00677f !important;\n  outline: 0;\n  background: #f3fafd;\n}\n.dropdown-seq > .button {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  line-height: 1.25;\n  position: relative;\n  cursor: pointer;\n}\n.dropdown-seq > div ul {\n  left: 0%;\n  top: 104%;\n  border: 1px solid #ccc;\n  background-color: #ffffff;\n  width: 100%;\n  position: absolute;\n  z-index: 1000;\n  max-height: 175px;\n  overflow-y: auto;\n  margin-bottom: 3rem;\n}\n.dropdown-seq > div ul li#default_option {\n  border-bottom: 1px solid #eee;\n}\n.dropdown-seq > div ul li {\n  padding: 0.5rem 0.75rem !important;\n  line-height: 1.25;\n  cursor: pointer;\n}\n.dropdown-seq > div ul li span {\n  color: #1B3B58;\n  text-decoration: none;\n  display: inline-block;\n}\n.dropdown-seq > div ul li:hover {\n  background: #007bff;\n}\n.dropdown-seq > div ul li:hover span {\n  color: #ffffff;\n}\n.dropdown-seq > div ul li[aria-selected=true] {\n  background: #eeeeee;\n  font-weight: bold;\n}\n.dropdown-seq > div ul li[aria-selected=true] span {\n  color: #051d33;\n}\n.dropdown-seq .dropdown_overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n  z-index: 1;\n}\n.dropdown-seq.disabled {\n  pointer-events: none;\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}\n\n.drop-down-error {\n  color: #ab1212;\n  border: 1px solid #ab1212;\n}\n.drop-down-error .button {\n  color: #051d33;\n}\n\n.error-msg {\n  margin-top: 0.2rem;\n  font-size: 0.775rem;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n  color: #ab1212;\n}";
  styleInject(css_248z$8);

  var Dropdown = function Dropdown(_ref) {
    var title = _ref.title,
      list = _ref.list,
      getOption = _ref.getOption,
      color = _ref.color,
      isDisabled = _ref.isDisabled,
      inScrollableContainer = _ref.inScrollableContainer,
      scrollableContainerSelector = _ref.scrollableContainerSelector,
      selectedItemProp = _ref.selectedItemProp,
      errorMessage = _ref.errorMessage,
      defaultWidth = _ref.defaultWidth,
      defaultOption = _ref.defaultOption,
      handleBlurGetOptionFlag = _ref.handleBlurGetOptionFlag;
    var _useState = React.useState({
        bottom: 0,
        top: 0,
        left: 0
      }),
      _useState2 = _slicedToArray$1(_useState, 2),
      boxPosition = _useState2[0],
      setBoxPosition = _useState2[1];
    var _useState3 = React.useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];
    var _useState5 = React.useState({
        Id: null
      }),
      _useState6 = _slicedToArray$1(_useState5, 2),
      selectedItem = _useState6[0],
      setSelectedItem = _useState6[1];
    var _useState7 = React.useState(''),
      _useState8 = _slicedToArray$1(_useState7, 2),
      dropdownTitle = _useState8[0],
      setDropdownTitle = _useState8[1];
    var _useState9 = React.useState(true),
      _useState10 = _slicedToArray$1(_useState9, 2),
      display = _useState10[0],
      setDisplay = _useState10[1];
    React.useEffect(function () {
      setDropdownTitle(title);
    }, [title]);
    React.useEffect(function () {
      if (typeof selectedItemProp === 'string' && selectedItemProp.length > 0) {
        var pickedItem = null;
        var pickedOption = '';
        for (var i = 0; i < list.length; i++) {
          var _list$i = list[i],
            Id = _list$i.Id,
            option = _list$i.option;
          if (Id === selectedItemProp) {
            pickedItem = list[i];
            pickedOption = option;
            break;
          }
        }
        if (pickedItem) {
          setSelectedItem(pickedItem);
          setDropdownTitle(pickedOption);
        }
      }
    }, [selectedItemProp]);
    var boxRef = React.useRef();
    React.useEffect(function () {
      if (inScrollableContainer && boxRef !== null && boxRef.current !== null) {
        var _boxRef$current$getBo = boxRef.current.getBoundingClientRect(),
          bottom = _boxRef$current$getBo.bottom,
          top = _boxRef$current$getBo.top,
          left = _boxRef$current$getBo.left;
        setBoxPosition({
          bottom: bottom,
          top: top,
          left: left
        });
      }
    }, [isOpen]);
    var onScroll = _.throttle(function () {
      if (inScrollableContainer && boxRef !== null && boxRef.current !== null) {
        var containerBody = document.querySelector(scrollableContainerSelector);
        var _boxRef$current$getBo2 = boxRef.current.getBoundingClientRect(),
          bottom = _boxRef$current$getBo2.bottom,
          top = _boxRef$current$getBo2.top,
          left = _boxRef$current$getBo2.left;
        if (containerBody && containerBody.getBoundingClientRect().bottom > bottom && containerBody.getBoundingClientRect().top - 50 < top) {
          setDisplay(true);
        } else {
          setDisplay(false);
        }
        setBoxPosition({
          bottom: bottom,
          top: top,
          left: left
        });
      }
    }, 10);
    React.useEffect(function () {
      if (inScrollableContainer && isOpen) {
        var containerBody = document.querySelector(scrollableContainerSelector);
        document.addEventListener('scroll', onScroll);
        if (containerBody) {
          containerBody.addEventListener('scroll', onScroll);
        }
        return function () {
          document.removeEventListener('scroll', onScroll);
          var containerBody = document.querySelector(scrollableContainerSelector);
          if (containerBody) {
            containerBody.removeEventListener('scroll', onScroll);
          }
        };
      }
    }, [inScrollableContainer, isOpen]);
    var handleMenuVisibility = function handleMenuVisibility(e, keyboardEvent) {
      if (keyboardEvent) {
        e.persist();
        var codeVal = e.keyCode;
        if (codeVal === 13) {
          setIsOpen(!isOpen);
          getOption(selectedItem);
        } else if (codeVal === 40) {
          var _nextItem$option;
          var nextItem = selectedItem.option ? ArrayParser.getNextVal(list, selectedItem) : list[0];
          setSelectedItem(nextItem);
          setDropdownTitle((_nextItem$option = nextItem === null || nextItem === void 0 ? void 0 : nextItem.option) !== null && _nextItem$option !== void 0 ? _nextItem$option : '');
        } else if (codeVal === 38) {
          var _prevItem$option;
          var prevItem = ArrayParser.getPrevVal(list, selectedItem);
          setSelectedItem(prevItem);
          setDropdownTitle((_prevItem$option = prevItem === null || prevItem === void 0 ? void 0 : prevItem.option) !== null && _prevItem$option !== void 0 ? _prevItem$option : '');
        }
      } else {
        setIsOpen(!isOpen);
      }
    };
    var handleBlur = function handleBlur() {
      setIsOpen(false);
      if (selectedItem.option && handleBlurGetOptionFlag) {
        getOption(selectedItem);
      }
    };
    var setSelecteditem = function setSelecteditem(item) {
      var option = item.option;
      getOption(item);
      setSelectedItem(item);
      setDropdownTitle(option || '');
    };
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "dropdown dropdown-seq ".concat(isDisabled ? 'disabled' : '', " ").concat(errorMessage !== null ? 'drop-down-error' : ''),
      role: "button",
      tabIndex: 0,
      onClick: function onClick(e) {
        return handleMenuVisibility(e, false);
      },
      onKeyDown: function onKeyDown(e) {
        return handleMenuVisibility(e, true);
      },
      onBlur: function onBlur(e) {
        return handleBlur();
      },
      ref: boxRef
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "button"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, dropdownTitle), isOpen && /*#__PURE__*/React__default["default"].createElement(dist$2.exports.ChevronUp, {
      color: color
    }), !isOpen && /*#__PURE__*/React__default["default"].createElement(dist$2.exports.ChevronDown, {
      color: color
    })), isOpen && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("ul", {
      style: inScrollableContainer ? {
        display: display ? 'inline-block' : 'none',
        top: "".concat(boxPosition.bottom, "px"),
        left: "".concat(boxPosition.left, "px"),
        position: 'fixed',
        width: boxRef && boxRef.current ? defaultWidth || "".concat(boxRef.current.offsetWidth, "px") : 'auto'
      } : {},
      "aria-label": "dropdown",
      role: "listbox"
    }, defaultOption !== '' && /*#__PURE__*/React__default["default"].createElement("li", {
      key: "default_option",
      id: "default_option",
      onClick: function onClick() {
        return setSelecteditem({
          option: defaultOption,
          Id: 'default_option'
        });
      },
      role: "option",
      "aria-selected": selectedItem.Id === 'default_option'
    }, defaultOption), list.map(function (item) {
      return !(Object.prototype.hasOwnProperty.call(item, 'hidden') && item.hidden) && /*#__PURE__*/React__default["default"].createElement("li", {
        key: item.Id,
        id: item.Id,
        onClick: function onClick() {
          return setSelecteditem(item);
        },
        role: "option",
        "aria-selected": selectedItem.Id === item.Id
      }, /*#__PURE__*/React__default["default"].createElement("span", null, item.option));
    })))), errorMessage !== null && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "error-msg"
    }, errorMessage));
  };
  Dropdown.defaultProps = {
    list: [],
    getOption: function getOption() {
      return null;
    },
    title: '',
    color: '#051d33',
    isDisabled: false,
    inScrollableContainer: false,
    scrollableContainerSelector: '',
    selectedItemProp: '',
    errorMessage: null,
    defaultWidth: null,
    defaultOption: '',
    handleBlurGetOptionFlag: true
  };
  Dropdown.propTypes = {
    list: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
      Id: PropTypes__default["default"].string,
      option: PropTypes__default["default"].string
    })),
    getOption: PropTypes__default["default"].func,
    title: PropTypes__default["default"].string,
    color: PropTypes__default["default"].string,
    isDisabled: PropTypes__default["default"].bool,
    inScrollableContainer: PropTypes__default["default"].bool,
    scrollableContainerSelector: PropTypes__default["default"].string,
    selectedItemProp: PropTypes__default["default"].string,
    errorMessage: PropTypes__default["default"].string,
    defaultWidth: PropTypes__default["default"].string,
    defaultOption: PropTypes__default["default"].string,
    handleBlurGetOptionFlag: PropTypes__default["default"].bool
  };

  /*!
   * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
   */
  function _typeof$1(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof$1 = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof$1 = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof$1(obj);
  }

  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    }

    return target;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var noop = function noop() {};

  var _WINDOW = {};
  var _DOCUMENT = {};
  var _MUTATION_OBSERVER = null;
  var _PERFORMANCE = {
    mark: noop,
    measure: noop
  };

  try {
    if (typeof window !== 'undefined') _WINDOW = window;
    if (typeof document !== 'undefined') _DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') _PERFORMANCE = performance;
  } catch (e) {}

  var _ref = _WINDOW.navigator || {},
      _ref$userAgent = _ref.userAgent,
      userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

  var WINDOW = _WINDOW;
  var DOCUMENT = _DOCUMENT;
  var PERFORMANCE = _PERFORMANCE;
  !!WINDOW.document;
  var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
  ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

  var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
  var DEFAULT_FAMILY_PREFIX = 'fa';
  var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
  var DATA_FA_I2SVG = 'data-fa-i2svg';
  (function () {
    try {
      return process.env.NODE_ENV === 'production';
    } catch (e) {
      return false;
    }
  })();
  var DUOTONE_CLASSES = {
    GROUP: 'group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
  };

  var initial = WINDOW.FontAwesomeConfig || {};

  function getAttrConfig(attr) {
    var element = DOCUMENT.querySelector('script[' + attr + ']');

    if (element) {
      return element.getAttribute(attr);
    }
  }

  function coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
  }

  if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
    var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
    attrs.forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          attr = _ref2[0],
          key = _ref2[1];

      var val = coerce(getAttrConfig(attr));

      if (val !== undefined && val !== null) {
        initial[key] = val;
      }
    });
  }

  var _default = {
    familyPrefix: DEFAULT_FAMILY_PREFIX,
    replacementClass: DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
  };

  var _config = _objectSpread$1({}, _default, initial);

  if (!_config.autoReplaceSvg) _config.observeMutations = false;

  var config = _objectSpread$1({}, _config);

  WINDOW.FontAwesomeConfig = config;

  var w = WINDOW || {};
  if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
  if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
  if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
  if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
  var namespace = w[NAMESPACE_IDENTIFIER];

  var functions = [];

  var listener = function listener() {
    DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    loaded = 1;
    functions.map(function (fn) {
      return fn();
    });
  };

  var loaded = false;

  if (IS_DOM) {
    loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
    if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
  }

  var PENDING = 'pending';
  var SETTLED = 'settled';
  var FULFILLED = 'fulfilled';
  var REJECTED = 'rejected';

  var NOOP = function NOOP() {};

  var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
  var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
  var asyncQueue = [];
  var asyncTimer;

  function asyncFlush() {
    // run promise callbacks
    for (var i = 0; i < asyncQueue.length; i++) {
      asyncQueue[i][0](asyncQueue[i][1]);
    } // reset async asyncQueue


    asyncQueue = [];
    asyncTimer = false;
  }

  function asyncCall(callback, arg) {
    asyncQueue.push([callback, arg]);

    if (!asyncTimer) {
      asyncTimer = true;
      asyncSetTimer(asyncFlush, 0);
    }
  }

  function invokeResolver(resolver, promise) {
    function resolvePromise(value) {
      resolve(promise, value);
    }

    function rejectPromise(reason) {
      reject(promise, reason);
    }

    try {
      resolver(resolvePromise, rejectPromise);
    } catch (e) {
      rejectPromise(e);
    }
  }

  function invokeCallback(subscriber) {
    var owner = subscriber.owner;
    var settled = owner._state;
    var value = owner._data;
    var callback = subscriber[settled];
    var promise = subscriber.then;

    if (typeof callback === 'function') {
      settled = FULFILLED;

      try {
        value = callback(value);
      } catch (e) {
        reject(promise, e);
      }
    }

    if (!handleThenable(promise, value)) {
      if (settled === FULFILLED) {
        resolve(promise, value);
      }

      if (settled === REJECTED) {
        reject(promise, value);
      }
    }
  }

  function handleThenable(promise, value) {
    var resolved;

    try {
      if (promise === value) {
        throw new TypeError('A promises callback cannot return that same promise.');
      }

      if (value && (typeof value === 'function' || _typeof$1(value) === 'object')) {
        // then should be retrieved only once
        var then = value.then;

        if (typeof then === 'function') {
          then.call(value, function (val) {
            if (!resolved) {
              resolved = true;

              if (value === val) {
                fulfill(promise, val);
              } else {
                resolve(promise, val);
              }
            }
          }, function (reason) {
            if (!resolved) {
              resolved = true;
              reject(promise, reason);
            }
          });
          return true;
        }
      }
    } catch (e) {
      if (!resolved) {
        reject(promise, e);
      }

      return true;
    }

    return false;
  }

  function resolve(promise, value) {
    if (promise === value || !handleThenable(promise, value)) {
      fulfill(promise, value);
    }
  }

  function fulfill(promise, value) {
    if (promise._state === PENDING) {
      promise._state = SETTLED;
      promise._data = value;
      asyncCall(publishFulfillment, promise);
    }
  }

  function reject(promise, reason) {
    if (promise._state === PENDING) {
      promise._state = SETTLED;
      promise._data = reason;
      asyncCall(publishRejection, promise);
    }
  }

  function publish(promise) {
    promise._then = promise._then.forEach(invokeCallback);
  }

  function publishFulfillment(promise) {
    promise._state = FULFILLED;
    publish(promise);
  }

  function publishRejection(promise) {
    promise._state = REJECTED;
    publish(promise);

    if (!promise._handled && isNode) {
      global.process.emit('unhandledRejection', promise._data, promise);
    }
  }

  function notifyRejectionHandled(promise) {
    global.process.emit('rejectionHandled', promise);
  }
  /**
   * @class
   */


  function P(resolver) {
    if (typeof resolver !== 'function') {
      throw new TypeError('Promise resolver ' + resolver + ' is not a function');
    }

    if (this instanceof P === false) {
      throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
    }

    this._then = [];
    invokeResolver(resolver, this);
  }

  P.prototype = {
    constructor: P,
    _state: PENDING,
    _then: null,
    _data: undefined,
    _handled: false,
    then: function then(onFulfillment, onRejection) {
      var subscriber = {
        owner: this,
        then: new this.constructor(NOOP),
        fulfilled: onFulfillment,
        rejected: onRejection
      };

      if ((onRejection || onFulfillment) && !this._handled) {
        this._handled = true;

        if (this._state === REJECTED && isNode) {
          asyncCall(notifyRejectionHandled, this);
        }
      }

      if (this._state === FULFILLED || this._state === REJECTED) {
        // already resolved, call callback async
        asyncCall(invokeCallback, subscriber);
      } else {
        // subscribe
        this._then.push(subscriber);
      }

      return subscriber.then;
    },
    catch: function _catch(onRejection) {
      return this.then(null, onRejection);
    }
  };

  P.all = function (promises) {
    if (!Array.isArray(promises)) {
      throw new TypeError('You must pass an array to Promise.all().');
    }

    return new P(function (resolve, reject) {
      var results = [];
      var remaining = 0;

      function resolver(index) {
        remaining++;
        return function (value) {
          results[index] = value;

          if (! --remaining) {
            resolve(results);
          }
        };
      }

      for (var i = 0, promise; i < promises.length; i++) {
        promise = promises[i];

        if (promise && typeof promise.then === 'function') {
          promise.then(resolver(i), reject);
        } else {
          results[i] = promise;
        }
      }

      if (!remaining) {
        resolve(results);
      }
    });
  };

  P.race = function (promises) {
    if (!Array.isArray(promises)) {
      throw new TypeError('You must pass an array to Promise.race().');
    }

    return new P(function (resolve, reject) {
      for (var i = 0, promise; i < promises.length; i++) {
        promise = promises[i];

        if (promise && typeof promise.then === 'function') {
          promise.then(resolve, reject);
        } else {
          resolve(promise);
        }
      }
    });
  };

  P.resolve = function (value) {
    if (value && _typeof$1(value) === 'object' && value.constructor === P) {
      return value;
    }

    return new P(function (resolve) {
      resolve(value);
    });
  };

  P.reject = function (reason) {
    return new P(function (resolve, reject) {
      reject(reason);
    });
  };
  var meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
  };
  function insertCss(css) {
    if (!css || !IS_DOM) {
      return;
    }

    var style = DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = DOCUMENT.head.childNodes;
    var beforeChild = null;

    for (var i = headChildren.length - 1; i > -1; i--) {
      var child = headChildren[i];
      var tagName = (child.tagName || '').toUpperCase();

      if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
        beforeChild = child;
      }
    }

    DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
  }
  var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  function nextUniqueId() {
    var size = 12;
    var id = '';

    while (size-- > 0) {
      id += idPool[Math.random() * 62 | 0];
    }

    return id;
  }
  function htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
      return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
  }
  function joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function (acc, styleName) {
      return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
    }, '');
  }
  function transformIsMeaningful(transform) {
    return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
  }
  function transformForSvg(_ref) {
    var transform = _ref.transform,
        containerWidth = _ref.containerWidth,
        iconWidth = _ref.iconWidth;
    var outer = {
      transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
      transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
      transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
      outer: outer,
      inner: inner,
      path: path
    };
  }

  var ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
  };

  function fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (abstract.attributes && (abstract.attributes.fill || force)) {
      abstract.attributes.fill = 'black';
    }

    return abstract;
  }

  function deGroup(abstract) {
    if (abstract.tag === 'g') {
      return abstract.children;
    } else {
      return [abstract];
    }
  }

  function makeIconMasking (_ref) {
    var children = _ref.children,
        attributes = _ref.attributes,
        main = _ref.main,
        mask = _ref.mask,
        explicitMaskId = _ref.maskId,
        transform = _ref.transform;
    var mainWidth = main.width,
        mainPath = main.icon;
    var maskWidth = mask.width,
        maskPath = mask.icon;
    var trans = transformForSvg({
      transform: transform,
      containerWidth: maskWidth,
      iconWidth: mainWidth
    });
    var maskRect = {
      tag: 'rect',
      attributes: _objectSpread$1({}, ALL_SPACE, {
        fill: 'white'
      })
    };
    var maskInnerGroupChildrenMixin = mainPath.children ? {
      children: mainPath.children.map(fillBlack)
    } : {};
    var maskInnerGroup = {
      tag: 'g',
      attributes: _objectSpread$1({}, trans.inner),
      children: [fillBlack(_objectSpread$1({
        tag: mainPath.tag,
        attributes: _objectSpread$1({}, mainPath.attributes, trans.path)
      }, maskInnerGroupChildrenMixin))]
    };
    var maskOuterGroup = {
      tag: 'g',
      attributes: _objectSpread$1({}, trans.outer),
      children: [maskInnerGroup]
    };
    var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
    var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
    var maskTag = {
      tag: 'mask',
      attributes: _objectSpread$1({}, ALL_SPACE, {
        id: maskId,
        maskUnits: 'userSpaceOnUse',
        maskContentUnits: 'userSpaceOnUse'
      }),
      children: [maskRect, maskOuterGroup]
    };
    var defs = {
      tag: 'defs',
      children: [{
        tag: 'clipPath',
        attributes: {
          id: clipId
        },
        children: deGroup(maskPath)
      }, maskTag]
    };
    children.push(defs, {
      tag: 'rect',
      attributes: _objectSpread$1({
        fill: 'currentColor',
        'clip-path': "url(#".concat(clipId, ")"),
        mask: "url(#".concat(maskId, ")")
      }, ALL_SPACE)
    });
    return {
      children: children,
      attributes: attributes
    };
  }

  function makeIconStandard (_ref) {
    var children = _ref.children,
        attributes = _ref.attributes,
        main = _ref.main,
        transform = _ref.transform,
        styles = _ref.styles;
    var styleString = joinStyles(styles);

    if (styleString.length > 0) {
      attributes['style'] = styleString;
    }

    if (transformIsMeaningful(transform)) {
      var trans = transformForSvg({
        transform: transform,
        containerWidth: main.width,
        iconWidth: main.width
      });
      children.push({
        tag: 'g',
        attributes: _objectSpread$1({}, trans.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread$1({}, trans.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread$1({}, main.icon.attributes, trans.path)
          }]
        }]
      });
    } else {
      children.push(main.icon);
    }

    return {
      children: children,
      attributes: attributes
    };
  }

  function asIcon (_ref) {
    var children = _ref.children,
        main = _ref.main,
        mask = _ref.mask,
        attributes = _ref.attributes,
        styles = _ref.styles,
        transform = _ref.transform;

    if (transformIsMeaningful(transform) && main.found && !mask.found) {
      var width = main.width,
          height = main.height;
      var offset = {
        x: width / height / 2,
        y: 0.5
      };
      attributes['style'] = joinStyles(_objectSpread$1({}, styles, {
        'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
      }));
    }

    return [{
      tag: 'svg',
      attributes: attributes,
      children: children
    }];
  }

  function asSymbol (_ref) {
    var prefix = _ref.prefix,
        iconName = _ref.iconName,
        children = _ref.children,
        attributes = _ref.attributes,
        symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
    return [{
      tag: 'svg',
      attributes: {
        style: 'display: none;'
      },
      children: [{
        tag: 'symbol',
        attributes: _objectSpread$1({}, attributes, {
          id: id
        }),
        children: children
      }]
    }];
  }

  function makeInlineSvgAbstract(params) {
    var _params$icons = params.icons,
        main = _params$icons.main,
        mask = _params$icons.mask,
        prefix = params.prefix,
        iconName = params.iconName,
        transform = params.transform,
        symbol = params.symbol,
        title = params.title,
        maskId = params.maskId,
        titleId = params.titleId,
        extra = params.extra,
        _params$watchable = params.watchable,
        watchable = _params$watchable === void 0 ? false : _params$watchable;

    var _ref = mask.found ? mask : main,
        width = _ref.width,
        height = _ref.height;

    var isUploadedIcon = prefix === 'fak';
    var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
    var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
      return extra.classes.indexOf(c) === -1;
    }).filter(function (c) {
      return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
      children: [],
      attributes: _objectSpread$1({}, extra.attributes, {
        'data-prefix': prefix,
        'data-icon': iconName,
        'class': attrClass,
        'role': extra.attributes.role || 'img',
        'xmlns': 'http://www.w3.org/2000/svg',
        'viewBox': "0 0 ".concat(width, " ").concat(height)
      })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
      width: "".concat(width / height * 16 * 0.0625, "em")
    } : {};

    if (watchable) {
      content.attributes[DATA_FA_I2SVG] = '';
    }

    if (title) content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });

    var args = _objectSpread$1({}, content, {
      prefix: prefix,
      iconName: iconName,
      main: main,
      mask: mask,
      maskId: maskId,
      transform: transform,
      symbol: symbol,
      styles: _objectSpread$1({}, uploadedIconWidthStyle, extra.styles)
    });

    var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
        children = _ref2.children,
        attributes = _ref2.attributes;

    args.children = children;
    args.attributes = attributes;

    if (symbol) {
      return asSymbol(args);
    } else {
      return asIcon(args);
    }
  }

  var noop$1 = function noop() {};

  config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
    mark: noop$1,
    measure: noop$1
  };

  /**
   * Internal helper to bind a function known to have 4 arguments
   * to a given context.
   */

  var bindInternal4 = function bindInternal4(func, thisContext) {
    return function (a, b, c, d) {
      return func.call(thisContext, a, b, c, d);
    };
  };

  /**
   * # Reduce
   *
   * A fast object `.reduce()` implementation.
   *
   * @param  {Object}   subject      The object to reduce over.
   * @param  {Function} fn           The reducer function.
   * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
   * @param  {Object}   thisContext  The context for the reducer.
   * @return {mixed}                 The final result.
   */


  var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject),
        length = keys.length,
        iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
        i,
        key,
        result;

    if (initialValue === undefined) {
      i = 1;
      result = subject[keys[0]];
    } else {
      i = 0;
      result = initialValue;
    }

    for (; i < length; i++) {
      key = keys[i];
      result = iterator(result, subject[key], key, subject);
    }

    return result;
  };

  function defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks,
        skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = Object.keys(icons).reduce(function (acc, iconName) {
      var icon = icons[iconName];
      var expanded = !!icon.icon;

      if (expanded) {
        acc[icon.iconName] = icon.icon;
      } else {
        acc[iconName] = icon;
      }

      return acc;
    }, {});

    if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
      namespace.hooks.addPack(prefix, normalized);
    } else {
      namespace.styles[prefix] = _objectSpread$1({}, namespace.styles[prefix] || {}, normalized);
    }
    /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */


    if (prefix === 'fas') {
      defineIcons('fa', icons);
    }
  }

  var styles = namespace.styles,
      shims = namespace.shims;
  var build = function build() {
    var lookup = function lookup(reducer) {
      return reduce(styles, function (o, style, prefix) {
        o[prefix] = reduce(style, reducer, {});
        return o;
      }, {});
    };

    lookup(function (acc, icon, iconName) {
      if (icon[3]) {
        acc[icon[3]] = iconName;
      }

      return acc;
    });
    lookup(function (acc, icon, iconName) {
      var ligatures = icon[2];
      acc[iconName] = iconName;
      ligatures.forEach(function (ligature) {
        acc[ligature] = iconName;
      });
      return acc;
    });
    var hasRegular = 'far' in styles;
    reduce(shims, function (acc, shim) {
      var oldName = shim[0];
      var prefix = shim[1];
      var iconName = shim[2];

      if (prefix === 'far' && !hasRegular) {
        prefix = 'fas';
      }

      acc[oldName] = {
        prefix: prefix,
        iconName: iconName
      };
      return acc;
    }, {});
  };
  build();

  namespace.styles;
  function iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
      return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
      };
    }
  }

  function toHtml(abstractNodes) {
    var tag = abstractNodes.tag,
        _abstractNodes$attrib = abstractNodes.attributes,
        attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
        _abstractNodes$childr = abstractNodes.children,
        children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

    if (typeof abstractNodes === 'string') {
      return htmlEscape(abstractNodes);
    } else {
      return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
    }
  }

  var parseTransformString = function parseTransformString(transformString) {
    var transform = {
      size: 16,
      x: 0,
      y: 0,
      flipX: false,
      flipY: false,
      rotate: 0
    };

    if (!transformString) {
      return transform;
    } else {
      return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');

        if (first && rest === 'h') {
          acc.flipX = true;
          return acc;
        }

        if (first && rest === 'v') {
          acc.flipY = true;
          return acc;
        }

        rest = parseFloat(rest);

        if (isNaN(rest)) {
          return acc;
        }

        switch (first) {
          case 'grow':
            acc.size = acc.size + rest;
            break;

          case 'shrink':
            acc.size = acc.size - rest;
            break;

          case 'left':
            acc.x = acc.x - rest;
            break;

          case 'right':
            acc.x = acc.x + rest;
            break;

          case 'up':
            acc.y = acc.y - rest;
            break;

          case 'down':
            acc.y = acc.y + rest;
            break;

          case 'rotate':
            acc.rotate = acc.rotate + rest;
            break;
        }

        return acc;
      }, transform);
    }
  };

  function MissingIcon(error) {
    this.name = 'MissingIcon';
    this.message = error || 'Icon unavailable';
    this.stack = new Error().stack;
  }
  MissingIcon.prototype = Object.create(Error.prototype);
  MissingIcon.prototype.constructor = MissingIcon;

  var FILL = {
    fill: 'currentColor'
  };
  var ANIMATION_BASE = {
    attributeType: 'XML',
    repeatCount: 'indefinite',
    dur: '2s'
  };
  ({
    tag: 'path',
    attributes: _objectSpread$1({}, FILL, {
      d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
    })
  });

  var OPACITY_ANIMATE = _objectSpread$1({}, ANIMATION_BASE, {
    attributeName: 'opacity'
  });

  ({
    tag: 'circle',
    attributes: _objectSpread$1({}, FILL, {
      cx: '256',
      cy: '364',
      r: '28'
    }),
    children: [{
      tag: 'animate',
      attributes: _objectSpread$1({}, ANIMATION_BASE, {
        attributeName: 'r',
        values: '28;14;28;28;14;28;'
      })
    }, {
      tag: 'animate',
      attributes: _objectSpread$1({}, OPACITY_ANIMATE, {
        values: '1;0;1;1;0;1;'
      })
    }]
  });
  ({
    tag: 'path',
    attributes: _objectSpread$1({}, FILL, {
      opacity: '1',
      d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
    }),
    children: [{
      tag: 'animate',
      attributes: _objectSpread$1({}, OPACITY_ANIMATE, {
        values: '1;0;0;0;0;1;'
      })
    }]
  });
  ({
    tag: 'path',
    attributes: _objectSpread$1({}, FILL, {
      opacity: '0',
      d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
    }),
    children: [{
      tag: 'animate',
      attributes: _objectSpread$1({}, OPACITY_ANIMATE, {
        values: '0;0;1;1;0;0;'
      })
    }]
  });

  namespace.styles;
  function asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];

    var _icon$slice = icon.slice(4),
        _icon$slice2 = _slicedToArray(_icon$slice, 1),
        vectorData = _icon$slice2[0];

    var element = null;

    if (Array.isArray(vectorData)) {
      element = {
        tag: 'g',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
        },
        children: [{
          tag: 'path',
          attributes: {
            class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
            fill: 'currentColor',
            d: vectorData[0]
          }
        }, {
          tag: 'path',
          attributes: {
            class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
            fill: 'currentColor',
            d: vectorData[1]
          }
        }]
      };
    } else {
      element = {
        tag: 'path',
        attributes: {
          fill: 'currentColor',
          d: vectorData
        }
      };
    }

    return {
      found: true,
      width: width,
      height: height,
      icon: element
    };
  }

  namespace.styles;

  var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

  function css () {
    var dfp = DEFAULT_FAMILY_PREFIX;
    var drc = DEFAULT_REPLACEMENT_CLASS;
    var fp = config.familyPrefix;
    var rc = config.replacementClass;
    var s = baseStyles;

    if (fp !== dfp || rc !== drc) {
      var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
      var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
      var rPatt = new RegExp("\\.".concat(drc), 'g');
      s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }

    return s;
  }

  var Library =
  /*#__PURE__*/
  function () {
    function Library() {
      _classCallCheck$1(this, Library);

      this.definitions = {};
    }

    _createClass$1(Library, [{
      key: "add",
      value: function add() {
        var _this = this;

        for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
          definitions[_key] = arguments[_key];
        }

        var additions = definitions.reduce(this._pullDefinitions, {});
        Object.keys(additions).forEach(function (key) {
          _this.definitions[key] = _objectSpread$1({}, _this.definitions[key] || {}, additions[key]);
          defineIcons(key, additions[key]);
          build();
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        this.definitions = {};
      }
    }, {
      key: "_pullDefinitions",
      value: function _pullDefinitions(additions, definition) {
        var normalized = definition.prefix && definition.iconName && definition.icon ? {
          0: definition
        } : definition;
        Object.keys(normalized).map(function (key) {
          var _normalized$key = normalized[key],
              prefix = _normalized$key.prefix,
              iconName = _normalized$key.iconName,
              icon = _normalized$key.icon;
          if (!additions[prefix]) additions[prefix] = {};
          additions[prefix][iconName] = icon;
        });
        return additions;
      }
    }]);

    return Library;
  }();

  function ensureCss() {
    if (config.autoAddCss && !_cssInserted) {
      insertCss(css());

      _cssInserted = true;
    }
  }

  function apiObject(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
      get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
      get: function get() {
        return val.abstract.map(function (a) {
          return toHtml(a);
        });
      }
    });
    Object.defineProperty(val, 'node', {
      get: function get() {
        if (!IS_DOM) return;
        var container = DOCUMENT.createElement('div');
        container.innerHTML = val.html;
        return container.children;
      }
    });
    return val;
  }

  function findIconDefinition(iconLookup) {
    var _iconLookup$prefix = iconLookup.prefix,
        prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
        iconName = iconLookup.iconName;
    if (!iconName) return;
    return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
  }

  function resolveIcons(next) {
    return function (maybeIconDefinition) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
      var mask = params.mask;

      if (mask) {
        mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
      }

      return next(iconDefinition, _objectSpread$1({}, params, {
        mask: mask
      }));
    };
  }

  var library = new Library();
  var _cssInserted = false;
  var parse = {
    transform: function transform(transformString) {
      return parseTransformString(transformString);
    }
  };
  var icon = resolveIcons(function (iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform,
        transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
        _params$symbol = params.symbol,
        symbol = _params$symbol === void 0 ? false : _params$symbol,
        _params$mask = params.mask,
        mask = _params$mask === void 0 ? null : _params$mask,
        _params$maskId = params.maskId,
        maskId = _params$maskId === void 0 ? null : _params$maskId,
        _params$title = params.title,
        title = _params$title === void 0 ? null : _params$title,
        _params$titleId = params.titleId,
        titleId = _params$titleId === void 0 ? null : _params$titleId,
        _params$classes = params.classes,
        classes = _params$classes === void 0 ? [] : _params$classes,
        _params$attributes = params.attributes,
        attributes = _params$attributes === void 0 ? {} : _params$attributes,
        _params$styles = params.styles,
        styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix,
        iconName = iconDefinition.iconName,
        icon = iconDefinition.icon;
    return apiObject(_objectSpread$1({
      type: 'icon'
    }, iconDefinition), function () {
      ensureCss();

      if (config.autoA11y) {
        if (title) {
          attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
        } else {
          attributes['aria-hidden'] = 'true';
          attributes['focusable'] = 'false';
        }
      }

      return makeInlineSvgAbstract({
        icons: {
          main: asFoundIcon(icon),
          mask: mask ? asFoundIcon(mask.icon) : {
            found: false,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: prefix,
        iconName: iconName,
        transform: _objectSpread$1({}, meaninglessTransform, transform),
        symbol: symbol,
        title: title,
        maskId: maskId,
        titleId: titleId,
        extra: {
          attributes: attributes,
          styles: styles,
          classes: classes
        }
      });
    });
  });

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys$1(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys$1(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties$1(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose$1(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  // Get CSS class list from a props object
  function classList(props) {
    var _classes;

    var spin = props.spin,
        pulse = props.pulse,
        fixedWidth = props.fixedWidth,
        inverse = props.inverse,
        border = props.border,
        listItem = props.listItem,
        flip = props.flip,
        size = props.size,
        rotation = props.rotation,
        pull = props.pull; // map of CSS class names to properties

    var classes = (_classes = {
      'fa-spin': spin,
      'fa-pulse': pulse,
      'fa-fw': fixedWidth,
      'fa-inverse': inverse,
      'fa-border': border,
      'fa-li': listItem,
      'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
      'fa-flip-vertical': flip === 'vertical' || flip === 'both'
    }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null

    return Object.keys(classes).map(function (key) {
      return classes[key] ? key : null;
    }).filter(function (key) {
      return key;
    });
  }

  // Camelize taken from humps
  // humps is copyright © 2012+ Dom Christie
  // Released under the MIT license.
  // Performant way to determine if object coerces to a number
  function _isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare

    return obj === obj;
  }

  function camelize(string) {
    if (_isNumerical(string)) {
      return string;
    } // eslint-disable-next-line no-useless-escape


    string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
      return chr ? chr.toUpperCase() : '';
    }); // Ensure 1st char is always lowercase

    return string.substr(0, 1).toLowerCase() + string.substr(1);
  }

  function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
  }

  function styleToObject(style) {
    return style.split(';').map(function (s) {
      return s.trim();
    }).filter(function (s) {
      return s;
    }).reduce(function (acc, pair) {
      var i = pair.indexOf(':');
      var prop = camelize(pair.slice(0, i));
      var value = pair.slice(i + 1).trim();
      prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
      return acc;
    }, {});
  }

  function convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof element === 'string') {
      return element;
    }

    var children = (element.children || []).map(function (child) {
      return convert(createElement, child);
    });
    /* eslint-disable dot-notation */

    var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
      var val = element.attributes[key];

      switch (key) {
        case 'class':
          acc.attrs['className'] = val;
          delete element.attributes['class'];
          break;

        case 'style':
          acc.attrs['style'] = styleToObject(val);
          break;

        default:
          if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
            acc.attrs[key.toLowerCase()] = val;
          } else {
            acc.attrs[camelize(key)] = val;
          }

      }

      return acc;
    }, {
      attrs: {}
    });

    var _extraProps$style = extraProps.style,
        existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
        remaining = _objectWithoutProperties$1(extraProps, ["style"]);

    mixins.attrs['style'] = _objectSpread2({}, mixins.attrs['style'], {}, existingStyle);
    /* eslint-enable */

    return createElement.apply(void 0, [element.tag, _objectSpread2({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray(children)));
  }

  var PRODUCTION = false;

  try {
    PRODUCTION = process.env.NODE_ENV === 'production';
  } catch (e) {}

  function log () {
    if (!PRODUCTION && console && typeof console.error === 'function') {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }

  function normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
      return icon;
    }

    if (parse.icon) {
      return parse.icon(icon);
    } // if the icon is null, there's nothing to do


    if (icon === null) {
      return null;
    } // if the icon is an object and has a prefix and an icon name, return it


    if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
      return icon;
    } // if it's an array with length of two


    if (Array.isArray(icon) && icon.length === 2) {
      // use the first item as prefix, second as icon name
      return {
        prefix: icon[0],
        iconName: icon[1]
      };
    } // if it's a string, use it as the icon name


    if (typeof icon === 'string') {
      return {
        prefix: 'fas',
        iconName: icon
      };
    }
  }

  // creates an object with a key of key
  // and a value of value
  // if certain conditions are met
  function objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
  }

  function FontAwesomeIcon(_ref) {
    var forwardedRef = _ref.forwardedRef,
        props = _objectWithoutProperties$1(_ref, ["forwardedRef"]);

    var iconArgs = props.icon,
        maskArgs = props.mask,
        symbol = props.symbol,
        className = props.className,
        title = props.title,
        titleId = props.titleId;
    var iconLookup = normalizeIconArgs(iconArgs);
    var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
    var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
    var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
    var renderedIcon = icon(iconLookup, _objectSpread2({}, classes, {}, transform, {}, mask, {
      symbol: symbol,
      title: title,
      titleId: titleId
    }));

    if (!renderedIcon) {
      log('Could not find icon', iconLookup);
      return null;
    }

    var abstract = renderedIcon.abstract;
    var extraProps = {
      ref: forwardedRef
    };
    Object.keys(props).forEach(function (key) {
      // eslint-disable-next-line no-prototype-builtins
      if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
        extraProps[key] = props[key];
      }
    });
    return convertCurry(abstract[0], extraProps);
  }
  FontAwesomeIcon.displayName = 'FontAwesomeIcon';
  FontAwesomeIcon.propTypes = {
    border: PropTypes__default["default"].bool,
    className: PropTypes__default["default"].string,
    mask: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].array, PropTypes__default["default"].string]),
    fixedWidth: PropTypes__default["default"].bool,
    inverse: PropTypes__default["default"].bool,
    flip: PropTypes__default["default"].oneOf(['horizontal', 'vertical', 'both']),
    icon: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].array, PropTypes__default["default"].string]),
    listItem: PropTypes__default["default"].bool,
    pull: PropTypes__default["default"].oneOf(['right', 'left']),
    pulse: PropTypes__default["default"].bool,
    rotation: PropTypes__default["default"].oneOf([0, 90, 180, 270]),
    size: PropTypes__default["default"].oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
    spin: PropTypes__default["default"].bool,
    symbol: PropTypes__default["default"].oneOfType([PropTypes__default["default"].bool, PropTypes__default["default"].string]),
    title: PropTypes__default["default"].string,
    transform: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].object]),
    swapOpacity: PropTypes__default["default"].bool
  };
  FontAwesomeIcon.defaultProps = {
    border: false,
    className: '',
    mask: null,
    fixedWidth: false,
    inverse: false,
    flip: null,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    symbol: false,
    title: '',
    transform: null,
    swapOpacity: false
  };
  var convertCurry = convert.bind(null, React__default["default"].createElement);

  /*!
   * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
   */
  var faSearch = {
    prefix: 'fas',
    iconName: 'search',
    icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"]
  };
  var faTimes = {
    prefix: 'fas',
    iconName: 'times',
    icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
  };

  var dist$1 = {exports: {}};

  (function (module, exports) {
  (function (global, factory) {
    module.exports = factory(React__default["default"], PropTypes__default["default"]) ;
  })(commonjsGlobal, (function (React, PropTypes) {
    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

    function guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return "".concat(s4(), "_").concat(s4(), "_").concat(s4(), "_").concat(s4());
    }

    function styleInject(css, ref) {
      if (ref === void 0) ref = {};
      var insertAt = ref.insertAt;

      if (!css || typeof document === 'undefined') {
        return;
      }

      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';

      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.tooltipContainer {\n  position: relative;\n  display: inline-block; }\n  .tooltipContainer:hover .tooltiptext {\n    visibility: visible;\n    opacity: 1; }\n  .tooltipContainer > div {\n    font-size: 1rem;\n    color: #051d33; }\n  .tooltipContainer .tooltiptext {\n    visibility: hidden;\n    min-width: 4rem;\n    text-align: center;\n    border-radius: 4px;\n    padding: 0.5rem;\n    transition: opacity 0.6s;\n    font-size: 1rem;\n    font-family: avenir_lt_medium;\n    background-color: #024055;\n    color: #ffffff;\n    text-shadow: none;\n    /* Position the tooltip */\n    position: fixed;\n    z-index: 1050;\n    text-transform: none; }\n    .tooltipContainer .tooltiptext.top::after {\n      content: ' ';\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      border-width: 5px;\n      border-style: solid;\n      border-color: #1b3b58 transparent transparent transparent; }\n    .tooltipContainer .tooltiptext.right::after {\n      content: ' ';\n      position: absolute;\n      right: 100%;\n      top: 50%;\n      transform: translateY(-50%);\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent #1b3b58 transparent transparent; }\n    .tooltipContainer .tooltiptext.left::after {\n      content: ' ';\n      position: absolute;\n      left: 100%;\n      top: 50%;\n      transform: translateY(-50%);\n      border-width: 6px;\n      border-style: solid;\n      border-color: transparent transparent transparent #1b3b58; }\n    .tooltipContainer .tooltiptext.bottom::after {\n      content: ' ';\n      position: absolute;\n      bottom: 100%;\n      left: 50%;\n      border-width: 5px;\n      border-style: solid;\n      border-color: transparent transparent #1b3b58 transparent; }\n";
    styleInject(css_248z);

    function ToolTip(_a) {
        var children = _a.children, message = _a.message, position = _a.position, width = _a.width;
        var class_temp = "tooltiptext ".concat(position);
        var _b = React.useState(undefined), xPos = _b[0], setXPos = _b[1];
        var _c = React.useState(undefined), yPos = _c[0], setYPos = _c[1];
        var id = guid();
        var handleonMouseMove = function (e) {
            e.persist();
            var thisDiv = e.target;
            var toolTipClass = thisDiv.className;
            if (toolTipClass.toString() !== class_temp) {
                var offset = 20;
                var thisSpan = document.getElementById(id);
                if (thisSpan) {
                    var toolTipWidth = thisSpan.offsetWidth;
                    var toolTipHeight = thisSpan.offsetHeight;
                    if (position === 'top') {
                        setYPos(e.clientY - offset - toolTipHeight);
                        setXPos(e.clientX - toolTipWidth / 2);
                    }
                    if (position === 'bottom') {
                        setYPos(e.clientY + offset);
                        setXPos(e.clientX - toolTipWidth / 2);
                    }
                    if (position === 'right') {
                        setYPos(e.clientY - toolTipHeight / 2);
                        setXPos(e.clientX + offset);
                    }
                    if (position === 'left') {
                        setYPos(e.clientY - toolTipHeight / 2);
                        setXPos(e.clientX - offset - toolTipWidth);
                    }
                }
            }
        };
        return (React__default["default"].createElement("div", { className: 'tooltipContainer', onMouseMove: handleonMouseMove },
            React__default["default"].createElement("span", { style: { top: yPos, left: xPos, maxWidth: width }, id: id, className: class_temp }, message),
            React__default["default"].createElement("div", null, children)));
    }
    ToolTip.defaultProps = {
        message: '',
        position: 'top',
        children: '',
        width: '15rem'
    };
    ToolTip.propTypes = {
        message: PropTypes__default["default"].string,
        position: PropTypes__default["default"].string,
        children: PropTypes__default["default"].any,
        width: PropTypes__default["default"].string // Used as the max width for the tool tip container
    };

    return ToolTip;

  }));
  }(dist$1));

  var ToolTip = dist$1.exports;

  /* eslint-disable max-len */
  // GENERATED STATIC MESSAGES

  var msg = {
    en: {},
    fr: {}
  };

  /**
   * @typedef {{
   *  en: Object.<string, string>,
   *  fr: Object.<string, string>
   * }} Translation
   */

  /**
   * Returns partial function that attempts to find the key in the ebject(s) passed to return
   * the tranlated value with respect to user lang in redux.
   * If unable to find, checks default message library.
   * If still unable to find the matching key, returns the key
   * @param {Translation} translateFiles
   * @returns {Function} Partial function
   * // Second function
   * @param {String} key
   * @returns {String} Translated string with regards to language
   */

  function createTranslator() {
    var _window$globalState$l, _window, _window$globalState;
    for (var _len = arguments.length, translateFiles = new Array(_len), _key = 0; _key < _len; _key++) {
      translateFiles[_key] = arguments[_key];
    }
    var lang = (_window$globalState$l = (_window = window) === null || _window === void 0 ? void 0 : (_window$globalState = _window.globalState) === null || _window$globalState === void 0 ? void 0 : _window$globalState.lang) !== null && _window$globalState$l !== void 0 ? _window$globalState$l : 'en';
    return function (key) {
      var _ref, _translation$0$lang$k, _translation$, _translation$$lang, _messages$lang;
      var translation = translateFiles === null || translateFiles === void 0 ? void 0 : translateFiles.filter(function (file) {
        var _file$lang;
        return file === null || file === void 0 ? void 0 : (_file$lang = file[lang]) === null || _file$lang === void 0 ? void 0 : _file$lang[key];
      });
      return (_ref = (_translation$0$lang$k = translation === null || translation === void 0 ? void 0 : (_translation$ = translation[0]) === null || _translation$ === void 0 ? void 0 : (_translation$$lang = _translation$[lang]) === null || _translation$$lang === void 0 ? void 0 : _translation$$lang[key]) !== null && _translation$0$lang$k !== void 0 ? _translation$0$lang$k : msg === null || msg === void 0 ? void 0 : (_messages$lang = msg[lang]) === null || _messages$lang === void 0 ? void 0 : _messages$lang[key]) !== null && _ref !== void 0 ? _ref : key;
    };
  }

  // Focus on the input
  var useFocus = function useFocus() {
    var htmlElRef = React.useRef(null);
    var setFocus = function setFocus() {
      if (htmlElRef && htmlElRef.current && typeof htmlElRef.current.focus === 'function') {
        htmlElRef.current.focus();
      }
    };
    return [htmlElRef, setFocus];
  };

  var extractFilteredArray$1 = function extractFilteredArray(filterText, array) {
    return array.filter(function (unit) {
      var option = unit.option;
      return option.toLowerCase().includes(filterText);
    });
  };
  var checkAllChecked = function checkAllChecked(selectedMap, array) {
    for (var i = 0; i < array.length; i++) {
      var _unit$Id;
      var unit = array[i];
      if (!Object.prototype.hasOwnProperty.call(selectedMap, (_unit$Id = unit === null || unit === void 0 ? void 0 : unit.Id) !== null && _unit$Id !== void 0 ? _unit$Id : '')) {
        return false;
      }
    }
    return true;
  };

  var useOnClickOutsideToggle = function useOnClickOutsideToggle(toggleHandler) {
    var clickOutsideOptOutElementIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var wrapperRef = React.useRef(null);
    React.useEffect(function () {
      var listener = function listener(event) {
        var eventTarget = event.target;
        if (!wrapperRef.current || wrapperRef.current.contains(eventTarget)) {
          return;
        }
        if (Array.isArray(clickOutsideOptOutElementIds) && clickOutsideOptOutElementIds.length > 0) {
          // Iterate through all the elements that will not close the sidebar when it is clicked
          for (var i = 0; i < clickOutsideOptOutElementIds.length; i++) {
            var clickOutsideOptOutElement = document.getElementById(clickOutsideOptOutElementIds[i]);
            if (clickOutsideOptOutElement && clickOutsideOptOutElement.contains(eventTarget)) {
              return;
            }
          }
        }
        toggleHandler(event);
      };
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
      return function () {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      };
    }, [wrapperRef, toggleHandler]);
    return wrapperRef;
  };

  var css_248z$7 = "#generic_multi_select_dropdown {\n  position: relative;\n  min-width: 12rem;\n  max-width: 17rem;\n}\n#generic_multi_select_dropdown #generic_multi_select_box {\n  cursor: pointer;\n  display: inline-block;\n  border: 1px solid gray;\n  border-radius: 4px;\n  padding: 0.5rem;\n  height: 2rem;\n  color: black;\n  width: 100%;\n  position: relative;\n}\n#generic_multi_select_dropdown #generic_multi_select_box:hover {\n  margin: 0;\n  border: 1px solid #00677f !important;\n  outline: 0;\n  background: #f3fafd;\n}\n#generic_multi_select_dropdown #generic_multi_select_box svg {\n  position: absolute;\n  right: 3%;\n  top: 36%;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu {\n  border: 1px solid gray;\n  width: 100%;\n  background-color: #FFFFFF;\n  position: absolute;\n  line-height: normal;\n  z-index: 5;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_dropdown_searchbox {\n  width: 100%;\n  position: relative;\n  border-bottom: 0.0625rem solid #E6E6E6;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_dropdown_searchbox input {\n  border: none;\n  padding: 0.5rem;\n  height: 2rem;\n  width: 100%;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_dropdown_searchbox svg {\n  font-size: 1rem;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_dropdown_searchbox svg[data-icon=search] {\n  position: absolute;\n  top: 25%;\n  right: 5%;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_dropdown_searchbox svg[data-icon=times] {\n  position: absolute;\n  top: 25%;\n  right: 5%;\n  cursor: pointer;\n  opacity: 50%;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_dropdown_searchbox svg[data-icon=times]:hover {\n  opacity: 100%;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_select_all {\n  padding: 0.5rem;\n  border-bottom: 0.0625rem solid #E6E6E6;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_select_all:hover {\n  background-color: #F3FAFD;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu #generic_multi_select_select_all.chosen {\n  background-color: #F3FAFD;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu ul {\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: 14.5rem;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu ul#generic_multi_select_select_menu .generic_multi_select_list_item {\n  border-bottom: 0.0625rem solid #E6E6E6;\n  padding: 0.5rem;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu ul#generic_multi_select_select_menu .generic_multi_select_list_item:hover {\n  background-color: #F3FAFD;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu ul#generic_multi_select_select_menu .generic_multi_select_list_item.chosen {\n  background-color: #F3FAFD;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu ul#generic_multi_select_select_menu .generic_multi_select_list_item .tooltipContainer .tooltiptext {\n  max-width: 15rem;\n}\n#generic_multi_select_dropdown #generic_multi_select_dropdown_menu ul#generic_multi_select_select_menu .generic_multi_select_list_item .tooltipContainer > div {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 9rem;\n}";
  styleInject(css_248z$7);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
  var GenericMultiSelectDropdown = function GenericMultiSelectDropdown(props) {
    var barPlaceholder = props.barPlaceholder,
      getOptions = props.getOptions,
      list = props.list,
      menuPlaceholder = props.menuPlaceholder,
      selectedMapProp = props.selectedMapProp;
    var _useFocus = useFocus(),
      _useFocus2 = _slicedToArray$1(_useFocus, 2),
      inputRef = _useFocus2[0],
      setInputFocus = _useFocus2[1];
    var _useState = React.useState(list),
      _useState2 = _slicedToArray$1(_useState, 2),
      filteredArray = _useState2[0],
      setFilteredArray = _useState2[1];
    var _useState3 = React.useState(''),
      _useState4 = _slicedToArray$1(_useState3, 2),
      filterText = _useState4[0],
      setFilterText = _useState4[1];
    var _useState5 = React.useState({}),
      _useState6 = _slicedToArray$1(_useState5, 2),
      selectedMap = _useState6[0],
      setSelectedMap = _useState6[1];
    var _useState7 = React.useState(false),
      _useState8 = _slicedToArray$1(_useState7, 2),
      showMenu = _useState8[0],
      setShowMenu = _useState8[1];
    var _useState9 = React.useState(false),
      _useState10 = _slicedToArray$1(_useState9, 2),
      allChecked = _useState10[0],
      setAllChecked = _useState10[1];
    var messages = {
      en: {
        select_all: 'Select All'
      },
      fr: {
        select_all: 'Tout sélectionner'
      }
    };
    var translate = createTranslator(messages);
    var clickOutsideHandler = function clickOutsideHandler() {
      if (showMenu) {
        setShowMenu(false);
      }
    };
    var clickHandler = function clickHandler() {
      setShowMenu(!showMenu);
    };
    var wrapperRef = useOnClickOutsideToggle(clickOutsideHandler);
    React.useEffect(function () {
      var nextSelectedMap = {};
      setFilteredArray(list);
      list.forEach(function (unit) {
        var Id = unit.Id;
        if (Object.prototype.hasOwnProperty.call(selectedMap, Id)) {
          nextSelectedMap[Id] = Id;
        }
      });
      setSelectedMap(nextSelectedMap);
    }, [list]);
    React.useEffect(function () {
      if (selectedMapProp && _typeof$2(selectedMapProp) === 'object' && Object.keys(selectedMapProp).length !== Object.keys(selectedMap).length) {
        setSelectedMap(selectedMapProp);
      }
    }, [selectedMapProp]);
    var handleUnitFunction = function handleUnitFunction(flag, Id) {
      if (typeof flag === 'boolean') {
        var futureSelectedMap = _objectSpread({}, selectedMap);
        if (!Object.prototype.hasOwnProperty.call(futureSelectedMap, Id)) {
          futureSelectedMap[Id] = Id;
          setAllChecked(checkAllChecked(futureSelectedMap, filteredArray));
        } else {
          delete futureSelectedMap[Id];
          setAllChecked(false);
        }
        setSelectedMap(futureSelectedMap);
        getOptions(futureSelectedMap);
      }
    };
    var toggleCheckAllFunc = function toggleCheckAllFunc() {
      var futureSelectedMap = _objectSpread({}, selectedMap);
      if (!allChecked) {
        filteredArray.forEach(function (unit) {
          var Id = unit.Id;
          if (!Object.prototype.hasOwnProperty.call(selectedMap, Id)) {
            futureSelectedMap[Id] = Id;
          }
        });
      } else {
        filteredArray.forEach(function (unit) {
          var Id = unit.Id;
          if (Object.prototype.hasOwnProperty.call(selectedMap, Id)) {
            delete futureSelectedMap[Id];
          }
        });
      }
      setSelectedMap(futureSelectedMap);
      getOptions(futureSelectedMap);
      setAllChecked(!allChecked);
    };
    var onChangeHandler = function onChangeHandler(event) {
      var target = event.target;
      var value = target.value;
      setFilterText(value);
      var filterArray = extractFilteredArray$1(value.toLowerCase(), list);
      setFilteredArray(filterArray);
      setAllChecked(checkAllChecked(selectedMap, filterArray));
    };
    var clearText = function clearText() {
      onChangeHandler({
        target: {
          value: ''
        }
      });
      setInputFocus();
    };
    return /*#__PURE__*/React__default["default"].createElement("div", {
      ref: wrapperRef,
      id: "generic_multi_select_dropdown"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      id: "generic_multi_select_box",
      onClick: clickHandler
    }, /*#__PURE__*/React__default["default"].createElement("span", null, Object.keys(selectedMap).length === 0 ? menuPlaceholder : "".concat(Object.keys(selectedMap).length, " Selected")), !showMenu ? /*#__PURE__*/React__default["default"].createElement(dist$2.exports.ChevronDown, {
      color: "#051d33"
    }) : /*#__PURE__*/React__default["default"].createElement(dist$2.exports.ChevronUp, {
      color: "#051d33"
    })), showMenu && /*#__PURE__*/React__default["default"].createElement("div", {
      id: "generic_multi_select_dropdown_menu"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      id: "generic_multi_select_dropdown_searchbox"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      ref: inputRef,
      type: "text",
      placeholder: barPlaceholder,
      onChange: onChangeHandler,
      value: filterText
    }), filterText.length === 0 ? /*#__PURE__*/React__default["default"].createElement(FontAwesomeIcon, {
      icon: faSearch
    }) : /*#__PURE__*/React__default["default"].createElement("div", {
      className: "cross",
      onClick: function onClick() {
        return clearText();
      }
    }, /*#__PURE__*/React__default["default"].createElement(FontAwesomeIcon, {
      icon: faTimes
    }))), /*#__PURE__*/React__default["default"].createElement("div", {
      id: "generic_multi_select_select_all",
      className: "".concat(allChecked ? 'chosen' : '')
    }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
      id: "select_all",
      value: "select_all",
      changeHandler: function changeHandler(flag) {
        if (typeof flag === 'boolean') {
          toggleCheckAllFunc();
        }
      },
      ischecked: allChecked
    }, translate('select_all'))), /*#__PURE__*/React__default["default"].createElement("ul", {
      id: "generic_multi_select_select_menu"
    }, filteredArray.map(function (unit) {
      var Id = unit.Id,
        option = unit.option;
      return /*#__PURE__*/React__default["default"].createElement("li", {
        className: "generic_multi_select_list_item ".concat(Object.prototype.hasOwnProperty.call(selectedMap, Id) ? 'chosen' : ''),
        key: Id
      }, /*#__PURE__*/React__default["default"].createElement(CheckBox, {
        changeHandler: function changeHandler(flag) {
          return handleUnitFunction(flag, Id);
        },
        ischecked: Object.prototype.hasOwnProperty.call(selectedMap, Id),
        value: Id,
        id: Id
      }, option.length > 20 ? /*#__PURE__*/React__default["default"].createElement(ToolTip, {
        message: option,
        position: "top"
      }, option) : /*#__PURE__*/React__default["default"].createElement("div", null, option)));
    }))));
  };
  GenericMultiSelectDropdown.defaultProps = {
    barPlaceholder: 'Search for an item',
    menuPlaceholder: 'Select an item',
    getOptions: function getOptions() {
      return null;
    },
    selectedMapProp: null
  };
  GenericMultiSelectDropdown.propTypes = {
    barPlaceholder: PropTypes__default["default"].string,
    list: PropTypes__default["default"].array.isRequired,
    menuPlaceholder: PropTypes__default["default"].string,
    getOptions: PropTypes__default["default"].func,
    selectedMapProp: PropTypes__default["default"].object
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  var css_248z$6 = "/* Consolidation of frequently used colours throughout the repo */ /*\nSass Reset\n*/\nhtml, body, div, span, applet, object, iframe, h1, h2, h3, h4,\nh5, h6, p, blockquote, pre, a, abbr, acronym, address, big,\ncite, code, del, dfn, em, img, ins, kbd, q, s, samp, small,\nstrike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd,\nol, ul, li, fieldset, form, label, legend, table, caption,\ntbody, tfoot, thead, tr, th, td, article, aside, canvas,\ndetails, embed, figure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary, time, mark, audio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure, footer,\nheader, hgroup, menu, nav, section {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol, ul {\n  list-style: none;\n}\n\nblockquote, q {\n  quotes: none;\n}\n\nblockquote:before, blockquote:after {\n  content: \"\";\n  content: none;\n}\n\nq:before, q:after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n/* Consolidation of frequently used colours throughout the repo */\n.reports_page_title {\n  font-family: avenir_lt_roman;\n  font-weight: 900;\n  color: #051d33;\n  font-size: 1.5rem;\n  text-align: center;\n  margin: 1rem 0rem;\n}\n\nbody {\n  font-family: Calibri, sans-serif;\n  font-size: 16px;\n  scroll-behavior: smooth;\n}\n\n.grecaptcha-badge {\n  display: none;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-family: avenir_lt_medium, sans-serif;\n  color: #808285;\n  opacity: 0.8;\n  margin: 10px 0 10px;\n  font-weight: 600;\n}\n\nh2 {\n  font-size: 26px;\n}\n\nh3 {\n  font-size: 24px;\n}\n\nh4 {\n  font-size: 18px;\n}\n\nh5 {\n  font-size: 14px;\n}\n\n.panel {\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\n}\n\n.panel-heading {\n  padding: 10px 5px;\n}\n\n/* ReactWidgets - override defaults*/\n.rw-widget-container, .multiselect-main-div {\n  border-radius: 4px;\n  font-size: 1.2em;\n  height: 25px;\n}\n.rw-widget-container:focus-within, .multiselect-main-div:focus-within {\n  border: 1px solid #66afe9;\n  box-shadow: 0px 0px 5px #66afe9;\n  outline: none;\n}\n\n/* React modal effects */\n.ReactModal__Content {\n  opacity: 0;\n}\n\n.ReactModal__Content--after-open {\n  opacity: 1;\n  transition: opacity 500ms;\n}\n\n.ReactModal__Content--before-close {\n  opacity: 0;\n}\n\n/* DateRangePicker  (react-date-range)*/\n.rdrMonthPicker,\n.rdrYearPicker {\n  background-color: #eff2f7;\n  border-radius: 3px;\n  font-weight: bold;\n  font-size: 1.1em;\n}\n\n.rdrDefinedRangesWrapper {\n  width: auto !important;\n}\n\n.rdrDayNumber > span {\n  font-weight: bolder;\n}\n\n/* AmChart4 - override defaults*/\n.amcharts-amexport-item {\n  width: auto !important;\n  min-width: 30px !important;\n}\n\n.amcharts-amexport-label {\n  color: #000 !important;\n  font-size: 14px !important;\n  text-decoration: none !important;\n}\n\n.chartContainerPanel.--dailyPerformanceChartWeb svg {\n  overflow: hidden !important;\n}\n\n#error_notification {\n  position: fixed;\n  top: 48px;\n  right: 0;\n  left: 0;\n  z-index: 1000;\n}\n#error_notification #backdrop {\n  position: fixed;\n  top: 48px;\n  right: 0;\n  left: 0;\n  bottom: 36px;\n  background: #eee;\n  opacity: 0.4;\n  z-index: 1001;\n  cursor: not-allowed;\n}\n#error_notification .notification {\n  margin-top: 3rem;\n  width: 50%;\n  z-index: 1002;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);\n}\n\n.multiselect-main-div {\n  display: inline-block;\n  position: relative;\n  border: 1px solid gray;\n  padding: 6px;\n  min-height: 1.75rem;\n  color: black;\n  width: 23.5rem;\n  height: 2.063rem;\n}\n.multiselect-main-div input {\n  border: 0px;\n}\n.multiselect-main-div input:focus {\n  outline: none;\n}\n.multiselect-main-div .button {\n  display: block;\n  margin: auto;\n  flex-direction: row;\n  line-height: 1.25;\n  cursor: pointer;\n}\n.multiselect-main-div .button input {\n  border: 0px;\n  padding-left: 0.688rem;\n  width: 90%;\n}\n.multiselect-main-div .button .fa-search {\n  margin-top: 3px;\n}\n.multiselect-main-div .button input:focus {\n  border: 0px !important;\n}\n.multiselect-main-div ul {\n  top: 104%;\n  border: 1px solid #ccc;\n  background-color: #ffffff;\n  width: 100%;\n  position: absolute;\n  z-index: 1000;\n  max-height: 10.938rem;\n  overflow-y: auto;\n  margin-bottom: 3rem;\n  list-style-type: none;\n}\n.multiselect-main-div ul li {\n  padding: 0.5rem 0.75rem !important;\n  line-height: 1rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n}\n.multiselect-main-div ul li .checkbox_container {\n  width: 10%;\n}\n.multiselect-main-div ul li span {\n  color: #1B3B58;\n  text-decoration: none;\n  white-space: nowrap;\n  width: 185px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 0.2rem;\n}\n.multiselect-main-div li:hover {\n  background: #007bff;\n}\n.multiselect-main-div li:hover span {\n  color: #ffffff;\n}\n.multiselect-main-div .selected-true {\n  background: #f3fafd;\n}\n.multiselect-main-div .dropdown_overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: transparent;\n  z-index: 1;\n}";
  styleInject(css_248z$6);

  function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
  function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var MultipleSelectDropdown = /*#__PURE__*/function (_React$Component) {
    _inherits(MultipleSelectDropdown, _React$Component);
    var _super = _createSuper$2(MultipleSelectDropdown);
    function MultipleSelectDropdown(props) {
      var _this;
      _classCallCheck(this, MultipleSelectDropdown);
      _this = _super.call(this, props);
      _defineProperty$2(_assertThisInitialized(_this), "handleClickOutside", function (event) {
        if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
          _this.setState({
            isOpen: false
          });
        }
      });
      _defineProperty$2(_assertThisInitialized(_this), "setWrapperRef", function (node) {
        _this.wrapperRef = node;
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleMenuVisibility", function () {
        _this.setState({
          isOpen: true
        });
      });
      _defineProperty$2(_assertThisInitialized(_this), "escapeHandler", function (event) {
        if (event.keyCode === 27) {
          _this.setState({
            isOpen: false
          });
        }
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleChange", function (e) {
        var _this$props = _this.props,
          list = _this$props.list,
          handleChange = _this$props.handleChange;
        var filteredList = list.filter(function (data) {
          return data.campaignName.toLowerCase().includes(e.target.value.toLowerCase());
        });
        var selectedCampaignData = ___default["default"].filter(filteredList, {
          isSelected: true
        });
        var selectAll = selectedCampaignData.length === filteredList.length ? true : false;
        _this.setState({
          dropdownList: filteredList,
          selectAll: selectAll
        });
        handleChange(e.target.value);
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleSelectedOption", function (val, flag) {
        var _this$state = _this.state,
          dropdownList = _this$state.dropdownList,
          selectAll = _this$state.selectAll;
        var _this$props2 = _this.props,
          getResultSet = _this$props2.getResultSet,
          idKey = _this$props2.idKey,
          list = _this$props2.list;
        var newList = [];
        if (val === 'select') {
          var data = {};
          data.id = 'select';
          if (list.length === dropdownList.length) {
            getResultSet(data, !selectAll);
          } else {
            var selectedId = [];
            newList = dropdownList.map(function (item) {
              item.isSelected = !selectAll;
              selectedId.push(item.id);
              return item;
            });
            getResultSet(data, !selectAll, selectedId);
          }
          _this.setState({
            selectAll: !selectAll
          });
        } else {
          newList = dropdownList.map(function (item) {
            if (item[idKey] === val[idKey]) item.isSelected = flag;
            return item;
          });
          var selectedCampaignData = ___default["default"].filter(dropdownList, {
            isSelected: true
          });
          var _selectAll = selectedCampaignData.length === dropdownList.length ? true : false;
          _this.setState({
            dropdownList: newList,
            selectAll: _selectAll
          });
          getResultSet(val, flag);
        }
      });
      _this.state = {
        dropdownList: [],
        isOpen: false,
        onSearch: '',
        selectAll: false
      };
      return _this;
    }

    /* eslint-disable */
    _createClass(MultipleSelectDropdown, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside, false);
        var list = this.props.list;
        var filteredList = list.map(function (item) {
          if (_typeof$2(item) === 'object') {
            if (item.hasOwnProperty('isSelected')) return item;
            item.isSelected = false;
            return item;
          }
          return null;
        });
        this.setState({
          dropdownList: filteredList
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside, false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$state2 = this.state,
          isOpen = _this$state2.isOpen,
          dropdownList = _this$state2.dropdownList,
          onSearch = _this$state2.onSearch,
          selectAll = _this$state2.selectAll;
        var _this$props3 = this.props,
          idKey = _this$props3.idKey,
          optionKey = _this$props3.optionKey,
          title = _this$props3.title;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          ref: this.setWrapperRef,
          onKeyDown: this.escapeHandler
        }, /*#__PURE__*/React__default["default"].createElement("h5", {
          className: "groupTitle"
        }, title), /*#__PURE__*/React__default["default"].createElement("div", {
          className: "dropdown multiselect-main-div",
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this2.handleMenuVisibility();
          },
          onKeyDown: function onKeyDown() {
            return _this2.handleMenuVisibility();
          }
        }, /*#__PURE__*/React__default["default"].createElement("div", {
          className: "button"
        }, /*#__PURE__*/React__default["default"].createElement("input", {
          placeholder: "Search campaigns",
          value: onSearch,
          onChange: function onChange(e) {
            return _this2.handleChange(e);
          }
        }), /*#__PURE__*/React__default["default"].createElement(FontAwesomeIcon, {
          icon: faSearch
        })), isOpen && dropdownList.length > 0 && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("ul", null, /*#__PURE__*/React__default["default"].createElement("li", {
          className: "selected-".concat(selectAll),
          key: 'select',
          onClick: function onClick() {
            return _this2.handleSelectedOption('select');
          }
        }, selectAll ? /*#__PURE__*/React__default["default"].createElement(CheckBox, {
          ischecked: true,
          id: 'select'
        }) : '', !selectAll ? /*#__PURE__*/React__default["default"].createElement(CheckBox, {
          id: 'select'
        }) : '', /*#__PURE__*/React__default["default"].createElement("span", {
          title: 'select all'
        }, 'Select all')), dropdownList.map(function (item) {
          return /*#__PURE__*/React__default["default"].createElement("li", {
            className: "selected-".concat(item.isSelected),
            key: item[idKey],
            onClick: function onClick() {
              return _this2.handleSelectedOption(item, !item.isSelected);
            }
          }, item.isSelected ? /*#__PURE__*/React__default["default"].createElement(CheckBox, {
            ischecked: true,
            id: item.id
          }) : '', !item.isSelected ? /*#__PURE__*/React__default["default"].createElement(CheckBox, {
            id: item.id
          }) : '', /*#__PURE__*/React__default["default"].createElement("span", {
            title: item[optionKey]
          }, item[optionKey]));
        })))));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, state) {
        var filteredList = props.list.filter(function (data) {
          return data.campaignName.toLowerCase().includes(props.onSearch.toLowerCase());
        });
        var selectedCampaignData = ___default["default"].filter(filteredList, {
          isSelected: false
        });
        var selectedOption = selectedCampaignData.length > 0 ? false : true;
        if (state.dropdownList !== props.list) {
          return {
            dropdownList: filteredList,
            selectAll: selectedOption,
            onSearch: props.onSearch
          };
        }
        return null;
      }
    }]);
    return MultipleSelectDropdown;
  }(React__default["default"].Component);
  MultipleSelectDropdown.propTypes = {
    list: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    getResultSet: PropTypes__default["default"].func,
    handleChange: PropTypes__default["default"].func,
    idKey: PropTypes__default["default"].string,
    optionKey: PropTypes__default["default"].string,
    title: PropTypes__default["default"].string,
    onSearch: PropTypes__default["default"].string
  };
  MultipleSelectDropdown.defaultProps = {
    list: [],
    getResultSet: function getResultSet() {
      return null;
    },
    handleChange: function handleChange() {
      return null;
    },
    idKey: 'id',
    optionKey: 'option',
    title: '',
    onSearch: ''
  };

  var dist = {exports: {}};

  (function (module, exports) {
  (function (global, factory) {
    module.exports = factory(React__default["default"], PropTypes__default["default"]) ;
  })(commonjsGlobal, (function (React, PropTypes) {
    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

    var get = function (key, object, defaultValue) {
        return key.split('.').reduce(function (obj, nextKey) {
            if (typeof obj === 'object' && nextKey in obj) {
                return obj[nextKey];
            }
            return defaultValue;
        }, object);
    };
    var Feature = function (_a) {
        var featureId = _a.featureId, featureFlag = _a.featureFlag, _b = _a.children, children = _b === void 0 ? null : _b, _c = _a.defaultVal, defaultVal = _c === void 0 ? false : _c;
        var data = featureFlag.featureFlagObj;
        var isFeatureEnabled = featureId ? get(featureId, data, defaultVal) : defaultVal;
        if (isFeatureEnabled) {
            return children;
        }
        return React__default["default"].createElement("div", null);
    };
    Feature.defaultProps = {
        children: null,
        defaultVal: false
    };
    Feature.propTypes = {
        featureId: PropTypes__default["default"].string.isRequired,
        featureFlag: PropTypes__default["default"].shape({
            featureFlagObj: PropTypes__default["default"].objectOf(PropTypes__default["default"].bool).isRequired
        }).isRequired,
        children: PropTypes__default["default"].any,
        defaultVal: PropTypes__default["default"].bool
    };

    return Feature;

  }));
  }(dist));

  var Feature = dist.exports;

  var css_248z$5 = ".password_input {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  position: relative;\n  margin-bottom: 1.5rem;\n  width: unset;\n}\n.password_input div.input_bar {\n  display: flex;\n  flex: 1;\n  margin: 0.2em 0;\n  align-self: stretch;\n}\n.password_input div.input_bar .input {\n  display: flex;\n  flex: 1;\n}\n.password_input div.input_bar .input input {\n  flex: 1;\n  width: unset;\n  min-width: 150px;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid #c3c3c3;\n  padding: 0.575rem 0.75rem;\n  padding-right: 30px;\n  line-height: normal;\n  outline: none;\n}\n.password_input div.input_bar .input input:focus {\n  border: 1px solid #00677f;\n}\n.password_input div.input_bar .input input:hover {\n  margin: 0;\n  border: 1px solid #00677f;\n  outline: 0;\n  background: #f3fafd;\n}\n.password_input div.input_bar .input input:disabled {\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}\n.password_input div.input_bar .input input.error {\n  border: 1px solid #ab1212;\n}\n.password_input div.input_bar label {\n  padding-left: 0.1em;\n  font-size: 1rem;\n}\n.password_input div.input_bar .field-icon {\n  position: absolute;\n  display: flex;\n  align-self: center;\n  z-index: 2;\n  right: 5px;\n}\n.password_input div.input_bar .field-icon.--disabled {\n  pointer-events: none;\n}\n.password_input div.input_btn_link {\n  display: flex;\n  flex: 1;\n  align-self: flex-end;\n  font-size: 0.775rem;\n  max-width: 250px;\n}\n.password_input div.input_btn_link button {\n  border: none;\n  background: transparent;\n  text-align: right;\n  flex: 1;\n  text-decoration: underline;\n  color: #00677f;\n  font-size: 0.875rem;\n}\n.password_input div.error {\n  display: flex;\n  flex-direction: column;\n  color: #ab1212;\n  font-size: 0.775rem;\n}";
  styleInject(css_248z$5);

  function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
  function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var PasswordInput = /*#__PURE__*/function (_React$PureComponent) {
    _inherits(PasswordInput, _React$PureComponent);
    var _super = _createSuper$1(PasswordInput);
    function PasswordInput(props) {
      var _this;
      _classCallCheck(this, PasswordInput);
      _this = _super.call(this, props);
      _defineProperty$2(_assertThisInitialized(_this), "handlePasswordVisibility", function () {
        var _this$state = _this.state,
          active = _this$state.active,
          type = _this$state.type;
        var newType = type === 'password' ? 'text' : 'password';
        _this.setState({
          active: !active,
          type: newType
        });
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleCopyPaste", function (e) {
        var disableCopyPaste = _this.props.disableCopyPaste;
        if (disableCopyPaste) {
          e.preventDefault();
        }
      });
      _this.state = {
        active: false,
        type: 'password'
      };
      return _this;
    }
    _createClass(PasswordInput, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          changeHandler = _this$props.changeHandler,
          blurHandler = _this$props.blurHandler,
          isDisabled = _this$props.isDisabled,
          link = _this$props.link,
          errorMessage = _this$props.errorMessage,
          linkClickHandler = _this$props.linkClickHandler,
          featureId = _this$props.featureId,
          autoFocus = _this$props.autoFocus,
          auth = _this$props.auth,
          showIcon = _this$props.showIcon,
          id = _this$props.id,
          maxLength = _this$props.maxLength,
          autocomplete = _this$props.autocomplete;
        var featureFlag = auth.featureFlag;
        var _this$state2 = this.state,
          active = _this$state2.active,
          type = _this$state2.type;
        var defaultVal = true;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: "password_input",
          id: id
        }, /*#__PURE__*/React__default["default"].createElement("label", {
          htmlFor: id
        }, label), /*#__PURE__*/React__default["default"].createElement("div", {
          className: "input_bar"
        }, /*#__PURE__*/React__default["default"].createElement("div", {
          className: "input"
        }, /*#__PURE__*/React__default["default"].createElement("input", {
          className: errorMessage !== null ? 'error' : 'valid',
          placeholder: placeholder,
          type: type,
          name: name,
          onBlur: function onBlur(e) {
            return blurHandler(e);
          },
          onChange: function onChange(e) {
            return changeHandler(e);
          },
          disabled: isDisabled || false,
          autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          ,
          id: "input_".concat(id),
          "aria-labelledby": label,
          onPaste: function onPaste(e) {
            return _this2.handleCopyPaste(e);
          },
          maxLength: maxLength,
          autoComplete: autocomplete
        })), showIcon && /*#__PURE__*/React__default["default"].createElement("div", {
          className: "field-icon ".concat(isDisabled ? '--disabled' : ''),
          onClick: this.handlePasswordVisibility,
          onKeyPress: function onKeyPress() {
            return null;
          }
        }, /*#__PURE__*/React__default["default"].createElement(dist$2.exports.PasswordShowIcon, {
          active: active
        }))), /*#__PURE__*/React__default["default"].createElement("div", {
          className: errorMessage && errorMessage !== null ? 'error' : 'valid',
          id: "passwordInput_message"
        }, errorMessage !== '' ? /*#__PURE__*/React__default["default"].createElement("span", null, errorMessage) : /*#__PURE__*/React__default["default"].createElement("div", null)), /*#__PURE__*/React__default["default"].createElement("div", {
          className: "input_btn_link"
        }, /*#__PURE__*/React__default["default"].createElement(Feature, {
          featureId: featureId,
          featureFlag: featureFlag,
          defaultVal: defaultVal
        }, link && link !== '' && /*#__PURE__*/React__default["default"].createElement("button", {
          tabIndex: "-1",
          type: "button",
          onClick: linkClickHandler,
          disabled: isDisabled || false
        }, link))));
      }
    }]);
    return PasswordInput;
  }(React__default["default"].PureComponent);
  PasswordInput.propTypes = {
    label: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    name: PropTypes__default["default"].string,
    placeholder: PropTypes__default["default"].string,
    changeHandler: PropTypes__default["default"].func,
    blurHandler: PropTypes__default["default"].func,
    isDisabled: PropTypes__default["default"].bool,
    link: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    errorMessage: PropTypes__default["default"].any,
    linkClickHandler: PropTypes__default["default"].func,
    featureId: PropTypes__default["default"].string,
    autoFocus: PropTypes__default["default"].bool,
    auth: PropTypes__default["default"].object,
    showIcon: PropTypes__default["default"].bool,
    id: PropTypes__default["default"].string,
    disableCopyPaste: PropTypes__default["default"].bool,
    maxLength: PropTypes__default["default"].number,
    autocomplete: PropTypes__default["default"].oneOf(['on', 'off'])
  };
  PasswordInput.defaultProps = {
    label: '',
    name: '',
    placeholder: '',
    changeHandler: function changeHandler() {
      return null;
    },
    blurHandler: function blurHandler() {
      return null;
    },
    isDisabled: false,
    link: '',
    errorMessage: null,
    linkClickHandler: function linkClickHandler() {
      return null;
    },
    featureId: 'null',
    autoFocus: false,
    auth: {
      featureFlag: {}
    },
    showIcon: true,
    id: 'password',
    disableCopyPaste: false,
    maxLength: 255,
    autocomplete: 'on'
  };

  var css_248z$4 = "/* Consolidation of frequently used colours throughout the repo */\n.radioButton {\n  position: relative;\n  width: 100%;\n  background-color: #eeeeee;\n  border-radius: 0.25rem;\n  margin-bottom: 1.5rem;\n}\n.radioButton label {\n  align-items: flex-start;\n  display: flex;\n}\n.radioButton label#right {\n  flex-direction: row-reverse;\n}\n.radioButton label#left {\n  flex-direction: row;\n}\n.radioButton label span {\n  width: 100%;\n}\n.radioButton label span input[type=radio] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  color: #051d33;\n  position: absolute;\n  cursor: pointer;\n  height: 1rem;\n  width: 1rem;\n  border-radius: 50%;\n  border: 1px solid #051d33;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n.radioButton label span input[type=radio].radio-err {\n  border: 1px solid #ab1212;\n}\n.radioButton label span input[type=radio].disabled {\n  background-color: #eeeeee !important;\n  border: 1px solid #c3c3c3;\n}\n.radioButton label span label {\n  padding-left: 0.1em;\n  font-size: 1rem;\n}\n.radioButton label > span:nth-child(1) {\n  flex: 7 0px;\n}\n.radioButton label > span:nth-child(2) {\n  flex: 1 0px;\n}\n.radioButton label .checkmark {\n  position: absolute;\n  background-color: #ffffff;\n  border-radius: 50%;\n  border: 1px solid #707070;\n  height: 16px;\n  width: 16px;\n}\n.radioButton label .checkmark.disabled {\n  background-color: #eeeeee !important;\n}\n.radioButton label input:checked {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23051D33'/%3e%3c/svg%3e\");\n}\n.radioButton label input:checked ~ .checkmark {\n  background-color: #ffffff;\n}\n.radioButton .disabled {\n  cursor: not-allowed;\n}\n.radioButton .disabled input {\n  cursor: not-allowed;\n}";
  styleInject(css_248z$4);

  var RadioButton = function RadioButton(props) {
    var name = props.name,
      changeHandler = props.changeHandler,
      isDisabled = props.isDisabled,
      children = props.children,
      value = props.value,
      isChecked = props.isChecked,
      labelAlignment = props.labelAlignment,
      errorMessage = props.errorMessage;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "radioButton"
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: value,
      className: isDisabled ? 'disabled' : '',
      id: "".concat(labelAlignment)
    }, /*#__PURE__*/React__default["default"].createElement("span", null, children), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("input", {
      type: "radio",
      name: name,
      value: value,
      onChange: function onChange() {
        return changeHandler(value);
      },
      disabled: isDisabled || false,
      id: value,
      checked: isChecked,
      className: "".concat(isDisabled ? 'disabled' : 'enabled', " ").concat(errorMessage ? 'radio-err' : '')
    }))));
  };
  RadioButton.propTypes = {
    value: PropTypes__default["default"].string,
    children: PropTypes__default["default"].any,
    name: PropTypes__default["default"].string,
    errorMessage: PropTypes__default["default"].string,
    changeHandler: PropTypes__default["default"].func,
    isChecked: PropTypes__default["default"].bool,
    isDisabled: PropTypes__default["default"].bool,
    labelAlignment: PropTypes__default["default"].oneOf(['left,right'])
  };
  RadioButton.defaultProps = {
    value: '',
    children: '',
    name: '',
    errorMessage: null,
    changeHandler: function changeHandler() {
      return null;
    },
    isChecked: null,
    isDisabled: false,
    labelAlignment: 'right'
  };

  var extractFilteredArray = function extractFilteredArray(filterText, array) {
    return array.filter(function (unit) {
      var option = unit.option;
      return option.toLowerCase().includes(filterText);
    });
  };

  var css_248z$3 = "/* Consolidation of frequently used colours throughout the repo */\n.searchable_dropdown_container {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n  border: 1px solid #c3c3c3;\n  border-radius: 4px;\n}\n.searchable_dropdown_container:hover {\n  margin: 0;\n  border: 1px solid #00677f !important;\n  outline: 0;\n  background: #f3fafd;\n}\n.searchable_dropdown_container .button {\n  padding: 0.25rem 0.5rem;\n  min-height: 2rem;\n  color: black;\n  display: grid;\n  grid-template-columns: 94% 6%;\n  line-height: 1.25;\n  cursor: pointer;\n}\n.searchable_dropdown_container .button > svg {\n  position: absolute;\n  top: 38%;\n  right: 2.5%;\n}\n.searchable_dropdown_container ul {\n  top: 104%;\n  border: 1px solid #ccc;\n  background-color: #ffffff;\n  width: 100%;\n  position: absolute;\n  z-index: 1000;\n  max-height: 175px;\n  overflow-y: auto;\n  margin-bottom: 3rem;\n}\n.searchable_dropdown_container ul li.single_dropdown_list_item {\n  padding: 0.5rem 0.75rem !important;\n  line-height: 1.25;\n  cursor: pointer;\n}\n.searchable_dropdown_container ul li.single_dropdown_list_item span {\n  color: #1B3B58;\n  text-decoration: none;\n  display: inline-block;\n}\n.searchable_dropdown_container ul li.single_dropdown_list_item span:hover {\n  color: #ffffff !important;\n}\n.searchable_dropdown_container ul li.single_dropdown_searchbox {\n  width: 100%;\n  position: relative;\n  border-bottom: 0.0625rem solid #E6E6E6;\n}\n.searchable_dropdown_container ul li.single_dropdown_searchbox input {\n  border: none;\n  padding: 0.5rem;\n  height: 2rem;\n  width: 100%;\n}\n.searchable_dropdown_container ul li.single_dropdown_searchbox svg {\n  font-size: 1rem;\n}\n.searchable_dropdown_container ul li.single_dropdown_searchbox svg[data-icon=search] {\n  position: absolute;\n  top: 25%;\n  right: 5%;\n}\n.searchable_dropdown_container ul li.single_dropdown_searchbox svg[data-icon=times] {\n  position: absolute;\n  top: 25%;\n  right: 5%;\n  cursor: pointer;\n  opacity: 50%;\n}\n.searchable_dropdown_container ul li.single_dropdown_searchbox svg[data-icon=times]:hover {\n  opacity: 100%;\n}\n.searchable_dropdown_container ul li:hover.single_dropdown_list_item, .searchable_dropdown_container ul li[aria-selected=true].single_dropdown_list_item {\n  background: #007bff;\n}\n.searchable_dropdown_container ul li:hover.single_dropdown_list_item span, .searchable_dropdown_container ul li[aria-selected=true].single_dropdown_list_item span {\n  color: #ffffff;\n}\n.searchable_dropdown_container.disabled {\n  pointer-events: none;\n  background: #eeeeee;\n  border-radius: 4px;\n  border: 1px solid #c3c3c3;\n}\n.searchable_dropdown_container.disabled .button > span {\n  color: rgba(0, 0, 0, 0.5);\n}";
  styleInject(css_248z$3);

  var SearchableDropdown = function SearchableDropdown(props) {
    var searchPlaceholder = props.searchPlaceholder,
      title = props.title,
      list = props.list,
      getOption = props.getOption,
      color = props.color,
      isDisabled = props.isDisabled,
      inScrollableContainer = props.inScrollableContainer,
      scrollableContainerSelector = props.scrollableContainerSelector,
      selectedItemProp = props.selectedItemProp;
    var _useState = React.useState({
        bottom: 0,
        top: 0,
        left: 0
      }),
      _useState2 = _slicedToArray$1(_useState, 2),
      boxPosition = _useState2[0],
      setBoxPosition = _useState2[1];
    var _useState3 = React.useState(false),
      _useState4 = _slicedToArray$1(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];
    var _useState5 = React.useState({
        Id: null
      }),
      _useState6 = _slicedToArray$1(_useState5, 2),
      selectedItem = _useState6[0],
      setSelectedItem = _useState6[1];
    var _useState7 = React.useState(title),
      _useState8 = _slicedToArray$1(_useState7, 2),
      dropdownTitle = _useState8[0],
      setDropdownTitle = _useState8[1];
    var _useState9 = React.useState(true),
      _useState10 = _slicedToArray$1(_useState9, 2),
      display = _useState10[0],
      setDisplay = _useState10[1];
    var _useState11 = React.useState(list),
      _useState12 = _slicedToArray$1(_useState11, 2),
      filteredArray = _useState12[0],
      setFilteredArray = _useState12[1];
    var _useState13 = React.useState(''),
      _useState14 = _slicedToArray$1(_useState13, 2),
      filterText = _useState14[0],
      setFilterText = _useState14[1];
    var _useState15 = React.useState(false),
      _useState16 = _slicedToArray$1(_useState15, 2),
      listUpdate = _useState16[0],
      setListUpdate = _useState16[1];
    var _useFocus = useFocus(),
      _useFocus2 = _slicedToArray$1(_useFocus, 2),
      inputRef = _useFocus2[0],
      setInputFocus = _useFocus2[1];
    var clickOutsideHandler = function clickOutsideHandler() {
      if (isOpen) {
        setIsOpen(false);
      }
    };
    var boxRef = useOnClickOutsideToggle(clickOutsideHandler);
    React.useEffect(function () {
      setFilteredArray(list);
      setFilterText('');
    }, [list]);
    React.useEffect(function () {
      setDropdownTitle(title);
    }, [title]);
    React.useEffect(function () {
      setFilterText('');
      setDropdownTitle(title);
      setSelectedItem({
        Id: null
      });
    }, [isDisabled]);
    React.useEffect(function () {
      if (typeof selectedItemProp === 'string' && selectedItemProp.length > 0) {
        var pickedItem = null;
        var pickedOption = '';
        for (var i = 0; i < filteredArray.length; i++) {
          var _filteredArray$i = filteredArray[i],
            Id = _filteredArray$i.Id,
            option = _filteredArray$i.option;
          if (Id === selectedItemProp) {
            pickedItem = filteredArray[i];
            pickedOption = option;
            break;
          }
        }
        if (pickedItem) {
          setSelectedItem(pickedItem);
          setDropdownTitle(pickedOption);
        }
      }
    }, [selectedItemProp]);
    React.useEffect(function () {
      if (inScrollableContainer && boxRef !== null && boxRef.current !== null) {
        var _boxRef$current$getBo = boxRef.current.getBoundingClientRect(),
          bottom = _boxRef$current$getBo.bottom,
          top = _boxRef$current$getBo.top,
          left = _boxRef$current$getBo.left;
        setBoxPosition({
          bottom: bottom,
          top: top,
          left: left
        });
      }
    }, [isOpen]);
    var onScroll = _.throttle(function () {
      if (inScrollableContainer && boxRef !== null && boxRef.current !== null) {
        var containerBody = document.querySelector(scrollableContainerSelector);
        var _boxRef$current$getBo2 = boxRef.current.getBoundingClientRect(),
          bottom = _boxRef$current$getBo2.bottom,
          top = _boxRef$current$getBo2.top,
          left = _boxRef$current$getBo2.left;
        if (containerBody.getBoundingClientRect().bottom > bottom && containerBody.getBoundingClientRect().top - 50 < top) {
          setDisplay(true);
        } else {
          setDisplay(false);
        }
        setBoxPosition({
          bottom: bottom,
          top: top,
          left: left
        });
      }
    }, 10);
    React.useEffect(function () {
      if (inScrollableContainer && isOpen) {
        var containerBody = document.querySelector(scrollableContainerSelector);
        document.addEventListener('scroll', onScroll);
        containerBody.addEventListener('scroll', onScroll);
        return function () {
          document.removeEventListener('scroll', onScroll);
          containerBody.removeEventListener('scroll', onScroll);
        };
      }
    }, [inScrollableContainer, isOpen]);
    React.useEffect(function () {
      if (listUpdate) {
        setListUpdate(false);
      }
    }, [listUpdate]);
    var onChangeHandler = _.throttle(function (event) {
      var target = event.target;
      var value = target.value;
      setFilterText(value);
      var nextFilteredArray = extractFilteredArray(value.toLowerCase(), list);
      setFilteredArray(nextFilteredArray);
      setListUpdate(true);
    }, 300);
    var clearText = function clearText() {
      onChangeHandler({
        target: {
          value: ''
        }
      });
      setInputFocus();
    };
    var clickHandler = function clickHandler() {
      setIsOpen(!isOpen);
    };
    var handleKeyboard = function handleKeyboard(e) {
      e.persist();
      var codeVal = e.keyCode;
      if (codeVal === 13) {
        getOption(selectedItem);
        setIsOpen(false);
      } else if (codeVal === 40) {
        var _nextItem$option;
        var nextItem = selectedItem.option ? ArrayParser.getNextVal(filteredArray, selectedItem) : filteredArray[0];
        setSelectedItem(nextItem);
        setDropdownTitle((_nextItem$option = nextItem === null || nextItem === void 0 ? void 0 : nextItem.option) !== null && _nextItem$option !== void 0 ? _nextItem$option : '');
      } else if (codeVal === 38) {
        var _prevItem$option;
        var prevItem = ArrayParser.getPrevVal(filteredArray, selectedItem);
        setSelectedItem(prevItem);
        setDropdownTitle((_prevItem$option = prevItem === null || prevItem === void 0 ? void 0 : prevItem.option) !== null && _prevItem$option !== void 0 ? _prevItem$option : '');
      }
    };
    var setSelecteditem = function setSelecteditem(item) {
      var option = item.option;
      getOption(item);
      setSelectedItem(item);
      setDropdownTitle(option || '');
      setIsOpen(false);
    };
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "searchable_dropdown_container ".concat(isDisabled ? 'disabled' : ''),
      role: "button",
      tabIndex: 0,
      onKeyDown: handleKeyboard,
      ref: boxRef
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "button",
      onClick: clickHandler
    }, /*#__PURE__*/React__default["default"].createElement("span", null, dropdownTitle), !isOpen ? /*#__PURE__*/React__default["default"].createElement(dist$2.exports.ChevronDown, {
      color: color
    }) : /*#__PURE__*/React__default["default"].createElement(dist$2.exports.ChevronUp, {
      color: color
    })), isOpen && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement("ul", {
      style: inScrollableContainer ? {
        display: display ? 'inline-block' : 'none',
        top: "".concat(boxPosition.bottom, "px"),
        left: "".concat(boxPosition.left, "px"),
        position: 'fixed',
        width: boxRef && boxRef.current ? "".concat(boxRef.current.offsetWidth, "px") : 'auto'
      } : {},
      "aria-label": "dropdown",
      role: "listbox"
    }, /*#__PURE__*/React__default["default"].createElement("li", {
      className: "single_dropdown_searchbox"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      ref: inputRef,
      type: "text",
      placeholder: searchPlaceholder,
      onChange: onChangeHandler,
      value: filterText,
      id: "single_dropdown_text"
    }), filterText.length === 0 ? /*#__PURE__*/React__default["default"].createElement(FontAwesomeIcon, {
      icon: faSearch
    }) : /*#__PURE__*/React__default["default"].createElement("div", {
      className: "cross",
      onClick: function onClick() {
        return clearText();
      }
    }, /*#__PURE__*/React__default["default"].createElement(FontAwesomeIcon, {
      icon: faTimes
    }))), !listUpdate && filteredArray.map(function (item) {
      if (Object.prototype.hasOwnProperty.call(item, 'hidden') && item.hidden) {
        return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
      }
      return /*#__PURE__*/React__default["default"].createElement("li", {
        key: item.Id,
        id: item.Id,
        onClick: function onClick() {
          return setSelecteditem(item);
        },
        role: "option",
        "aria-selected": selectedItem.Id === item.Id,
        className: "single_dropdown_list_item"
      }, /*#__PURE__*/React__default["default"].createElement("span", null, item.option));
    }))));
  };
  SearchableDropdown.defaultProps = {
    searchPlaceholder: 'Search for an item',
    list: [],
    getOption: function getOption() {
      return null;
    },
    title: 'Select an item',
    color: '#c3c3c3',
    isDisabled: false,
    inScrollableContainer: false,
    scrollableContainerSelector: '',
    selectedItemProp: ''
  };
  SearchableDropdown.propTypes = {
    searchPlaceholder: PropTypes__default["default"].string,
    list: PropTypes__default["default"].array,
    getOption: PropTypes__default["default"].func,
    title: PropTypes__default["default"].string,
    color: PropTypes__default["default"].string,
    isDisabled: PropTypes__default["default"].bool,
    inScrollableContainer: PropTypes__default["default"].bool,
    scrollableContainerSelector: PropTypes__default["default"].string,
    selectedItemProp: PropTypes__default["default"].string
  };

  var css_248z$2 = "/* Consolidation of frequently used colours throughout the repo */\n.switch {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row-reverse;\n  position: relative;\n  max-width: 50px;\n  max-height: 25px;\n  min-width: 50px;\n  min-height: 25px;\n}\n.switch label {\n  width: 100%;\n  height: 25px;\n  cursor: pointer;\n  /* Rounded sliders */\n}\n.switch label ._hidden {\n  visibility: hidden;\n}\n.switch label input {\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100;\n  cursor: pointer;\n}\n.switch label .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: -1px;\n  bottom: 0;\n  background-color: rgb(112, 112, 112);\n  transition: 0.4s;\n}\n.switch label .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 21px;\n  width: 21px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n}\n.switch label input:checked + .slider {\n  background-color: #051d33;\n}\n.switch label input:focus + .slider {\n  box-shadow: 0 0 1px #051d33;\n}\n.switch label input:checked + .slider:before {\n  transform: translateX(26px);\n}\n.switch label .slider.round {\n  border-radius: 34px;\n}\n.switch label .slider.round:focus {\n  display: none;\n}\n.switch label .slider.round:before {\n  border-radius: 50%;\n}";
  styleInject(css_248z$2);

  var SwitchInput = function SwitchInput(_ref) {
    var name = _ref.name,
      changeHandler = _ref.changeHandler,
      isDisabled = _ref.isDisabled,
      children = _ref.children,
      value = _ref.value,
      checked = _ref.checked;
    var _useState = React.useState(checked),
      _useState2 = _slicedToArray$1(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];
    React.useEffect(function () {
      setIsChecked(checked);
    }, [checked]);
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "switch",
      tabIndex: isDisabled ? '-1' : '0',
      onKeyDown: function onKeyDown(event) {
        if (event.key === 'Enter') {
          event.persist();
          changeHandler(isChecked ? '' : value);
          setIsChecked(!isChecked);
        }
      }
    }, /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: value
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: children === '' ? '_hidden' : ''
    }, children === '' ? 'hidden' : children), /*#__PURE__*/React__default["default"].createElement("input", {
      type: "checkbox",
      name: name,
      value: value,
      id: value,
      checked: isChecked || checked,
      onChange: function onChange(event) {
        event.persist();
        var isInputChecked = event.target.checked;
        changeHandler(isInputChecked ? value : '');
        setIsChecked(isInputChecked);
      },
      disabled: isDisabled || false
    }), /*#__PURE__*/React__default["default"].createElement("span", {
      className: "slider round"
    })));
  };
  SwitchInput.propTypes = {
    value: PropTypes__default["default"].string,
    children: PropTypes__default["default"].any,
    name: PropTypes__default["default"].string,
    changeHandler: PropTypes__default["default"].func,
    isDisabled: PropTypes__default["default"].bool,
    checked: PropTypes__default["default"].bool
  };
  SwitchInput.defaultProps = {
    value: 'switch',
    children: '',
    name: '',
    changeHandler: function changeHandler() {
      return null;
    },
    isDisabled: false,
    checked: false
  };

  var css_248z$1 = ".textarea_input {\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n}\n.textarea_input #_hidden {\n  visibility: hidden;\n}\n.textarea_input span {\n  width: 100%;\n}\n.textarea_input span:focus {\n  outline: none;\n}\n.textarea_input span textarea {\n  min-width: 150px;\n  width: 100%;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid #c3c3c3;\n  padding: 0.575rem 0.75rem;\n  line-height: normal;\n  outline: none;\n}\n.textarea_input span textarea:focus {\n  border: 1px solid #00677f;\n}\n.textarea_input span textarea:hover {\n  margin: 0;\n  border: 1px solid #00677f;\n  outline: 0;\n  background: #f3fafd;\n}\n.textarea_input span textarea:disabled {\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}\n.textarea_input span textarea.error {\n  border: 1px solid #ab1212;\n}\n.textarea_input span button {\n  border: none;\n  background: transparent;\n  text-align: right;\n  width: 100%;\n  text-decoration: underline;\n  color: #00677f;\n  font-size: 0.875rem;\n  float: right;\n  width: auto;\n}\n.textarea_input span p {\n  padding-left: 0.1em;\n  font-size: 1rem;\n}\n.textarea_input span:nth-child(1) {\n  margin-bottom: 0.2em;\n}\n.textarea_input span:nth-child(3) {\n  margin-top: 0.2em;\n}\n.textarea_input span:nth-child(3) span:nth-child(1) {\n  font-size: 0.775rem;\n  padding-top: 0.2em;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n}\n.textarea_input span.error {\n  display: flex;\n  flex-direction: column;\n  color: #ab1212;\n}";
  styleInject(css_248z$1);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var TextArea = /*#__PURE__*/function (_React$Component) {
    _inherits(TextArea, _React$Component);
    var _super = _createSuper(TextArea);
    function TextArea(props) {
      var _this;
      _classCallCheck(this, TextArea);
      _this = _super.call(this, props);
      _defineProperty$2(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
        var value = _this.props.value;
        if (prevProps.value !== '' && value === '') {
          _this.setState({
            value: ''
          });
        }
      });
      _defineProperty$2(_assertThisInitialized(_this), "componentDidMount", function () {
        var value = _this.props.value;
        _this.setState({
          value: value
        });
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleCopyPaste", function (e) {
        var disableCopyPaste = _this.props.disableCopyPaste;
        if (disableCopyPaste) {
          e.preventDefault();
        }
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleBlur", function (e) {
        var blurHandler = _this.props.blurHandler;
        _this.setState({
          value: e.target.value
        });
        blurHandler(e.target.value);
      });
      _defineProperty$2(_assertThisInitialized(_this), "handlechange", function (e) {
        var changeHandler = _this.props.changeHandler;
        _this.setState({
          value: e.target.value
        });
        changeHandler(e.target.value);
      });
      _defineProperty$2(_assertThisInitialized(_this), "handleKeyPress", function (e) {
        var handleKeyPress = _this.props.handleKeyPress;
        handleKeyPress(e.target.value);
      });
      _this.state = {
        value: ''
      };
      return _this;
    }
    _createClass(TextArea, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          placeholder = _this$props.placeholder,
          isDisabled = _this$props.isDisabled,
          link = _this$props.link,
          errorMessage = _this$props.errorMessage,
          linkClickHandler = _this$props.linkClickHandler,
          featureId = _this$props.featureId,
          autoFocus = _this$props.autoFocus,
          auth = _this$props.auth,
          id = _this$props.id,
          maxLength = _this$props.maxLength,
          autocomplete = _this$props.autocomplete,
          type = _this$props.type,
          textMsg = _this$props.textMsg;
        var defaultVal = true;
        var featureFlag = auth.featureFlag;
        var value = this.state.value;
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: "textarea_input",
          id: id
        }, /*#__PURE__*/React__default["default"].createElement("span", {
          id: "".concat(label === '' ? '_hidden' : '')
        }, /*#__PURE__*/React__default["default"].createElement("p", {
          htmlFor: id
        }, label)), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("textarea", {
          className: errorMessage !== null ? 'error' : 'valid',
          placeholder: placeholder,
          value: value,
          type: type,
          name: name,
          onBlur: function onBlur(e) {
            return _this2.handleBlur(e);
          },
          onChange: function onChange(e) {
            return _this2.handlechange(e);
          },
          onPaste: function onPaste(e) {
            return _this2.handleCopyPaste(e);
          },
          onKeyPress: function onKeyPress(e) {
            return _this2.handleKeyPress(e);
          },
          disabled: isDisabled || false,
          autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          ,
          id: id,
          "aria-labelledby": id,
          maxLength: maxLength,
          autoComplete: autocomplete
        })), /*#__PURE__*/React__default["default"].createElement("span", null, textMsg), /*#__PURE__*/React__default["default"].createElement("span", {
          className: errorMessage && errorMessage !== null ? 'error' : 'valid'
        }, errorMessage !== '' ? /*#__PURE__*/React__default["default"].createElement("span", null, errorMessage) : /*#__PURE__*/React__default["default"].createElement("span", null), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(Feature, {
          featureId: featureId,
          featureFlag: featureFlag,
          defaultVal: defaultVal
        }, link && link !== '' && /*#__PURE__*/React__default["default"].createElement("button", {
          tabIndex: "-1",
          type: "button",
          onClick: linkClickHandler,
          disabled: isDisabled || false
        }, link)))));
      }
    }]);
    return TextArea;
  }(React__default["default"].Component);
  TextArea.propTypes = {
    label: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    name: PropTypes__default["default"].string,
    placeholder: PropTypes__default["default"].string,
    changeHandler: PropTypes__default["default"].func,
    blurHandler: PropTypes__default["default"].func,
    isDisabled: PropTypes__default["default"].bool,
    link: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    errorMessage: PropTypes__default["default"].any,
    linkClickHandler: PropTypes__default["default"].func,
    featureId: PropTypes__default["default"].string,
    autoFocus: PropTypes__default["default"].bool,
    auth: PropTypes__default["default"].object,
    id: PropTypes__default["default"].string,
    disableCopyPaste: PropTypes__default["default"].bool,
    maxLength: PropTypes__default["default"].number,
    autocomplete: PropTypes__default["default"].oneOf(['on', 'off']),
    value: PropTypes__default["default"].string,
    type: PropTypes__default["default"].string,
    textMsg: PropTypes__default["default"].string,
    handleKeyPress: PropTypes__default["default"].func
  };
  TextArea.defaultProps = {
    label: '',
    name: '',
    placeholder: '',
    changeHandler: function changeHandler() {
      return null;
    },
    blurHandler: function blurHandler() {
      return null;
    },
    isDisabled: false,
    link: '',
    errorMessage: null,
    linkClickHandler: function linkClickHandler() {
      return null;
    },
    featureId: 'null',
    autoFocus: false,
    auth: {
      featureFlag: {}
    },
    id: 'textarea',
    disableCopyPaste: false,
    maxLength: 255,
    autocomplete: 'on',
    value: '',
    type: 'text',
    textMsg: '',
    handleKeyPress: function handleKeyPress() {
      return null;
    }
  };

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }

  var css_248z = ".textInput_input {\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n}\n.textInput_input #_hidden {\n  visibility: hidden;\n}\n.textInput_input span {\n  width: 100%;\n}\n.textInput_input span:focus {\n  outline: none;\n}\n.textInput_input span input {\n  min-width: 150px;\n  width: 100%;\n  font-size: 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid #c3c3c3;\n  padding: 0.575rem 0.75rem;\n  line-height: normal;\n  outline: none;\n}\n.textInput_input span input:focus {\n  border: 1px solid #00677f;\n}\n.textInput_input span input:hover {\n  margin: 0;\n  border: 1px solid #00677f;\n  outline: 0;\n  background: #f3fafd;\n}\n.textInput_input span input:disabled {\n  border: 1px solid #c3c3c3;\n  background: #eeeeee;\n}\n.textInput_input span input.error {\n  border: 1px solid #ab1212;\n}\n.textInput_input span button {\n  border: none;\n  background: transparent;\n  text-align: right;\n  width: 100%;\n  text-decoration: underline;\n  color: #00677f;\n  font-size: 0.875rem;\n  float: right;\n  width: auto;\n}\n.textInput_input span p {\n  padding-left: 0.1em;\n  font-size: 1rem;\n}\n.textInput_input span:nth-child(1) {\n  margin-bottom: 0.2em;\n}\n.textInput_input span:nth-child(3) {\n  margin-top: 0.2em;\n}\n.textInput_input span:nth-child(3) span:nth-child(1) {\n  font-size: 0.775rem;\n  padding-top: 0.2em;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n}\n.textInput_input span.error {\n  display: flex;\n  flex-direction: column;\n  color: #ab1212;\n}";
  styleInject(css_248z);

  var _excluded = ["label", "name", "placeholder", "isDisabled", "link", "errorMessage", "linkClickHandler", "featureId", "autoFocus", "auth", "id", "autocomplete", "changeHandler", "blurHandler", "type", "maxLength", "disableCopyPaste", "value"];
  var TextInput = function TextInput(_ref) {
    var label = _ref.label,
      name = _ref.name,
      placeholder = _ref.placeholder,
      isDisabled = _ref.isDisabled,
      link = _ref.link,
      errorMessage = _ref.errorMessage,
      linkClickHandler = _ref.linkClickHandler,
      featureId = _ref.featureId,
      autoFocus = _ref.autoFocus,
      auth = _ref.auth,
      id = _ref.id,
      autocomplete = _ref.autocomplete,
      changeHandler = _ref.changeHandler,
      blurHandler = _ref.blurHandler,
      type = _ref.type,
      maxLength = _ref.maxLength,
      disableCopyPaste = _ref.disableCopyPaste,
      value = _ref.value,
      everythingElse = _objectWithoutProperties(_ref, _excluded);
    var _useState = React.useState(''),
      _useState2 = _slicedToArray$1(_useState, 2),
      valueState = _useState2[0],
      setValueState = _useState2[1];
    React.useEffect(function () {
      setValueState(value);
    }, [value]);
    var handleCopyPaste = function handleCopyPaste(e) {
      if (disableCopyPaste) {
        e.preventDefault();
      }
    };
    var handleBlur = function handleBlur(e) {
      var handleBlurValue = type === 'number' ? e.target.value.slice(0, maxLength) : e.target.value;
      setValueState(handleBlurValue);
      blurHandler(handleBlurValue);
    };
    var handleChange = function handleChange(e) {
      var handleChangeValue = type === 'number' ? e.target.value.slice(0, maxLength) : e.target.value;
      setValueState(handleChangeValue);
      changeHandler(handleChangeValue);
    };
    var featureFlag = auth.featureFlag;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "textInput_input"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      id: "".concat(label === '' ? '_hidden' : '')
    }, /*#__PURE__*/React__default["default"].createElement("p", {
      htmlFor: id
    }, label)), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement("input", _extends({
      className: errorMessage !== null ? 'error' : 'valid',
      placeholder: placeholder,
      value: valueState,
      type: type === 'number' ? 'number' : 'text',
      name: name,
      onBlur: handleBlur,
      onChange: handleChange,
      onPaste: handleCopyPaste,
      disabled: isDisabled || false,
      autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
      ,
      id: id,
      "aria-labelledby": id,
      maxLength: maxLength,
      autoComplete: autocomplete
    }, everythingElse))), /*#__PURE__*/React__default["default"].createElement("span", {
      className: errorMessage && errorMessage !== null ? 'error' : 'valid'
    }, errorMessage !== '' ? /*#__PURE__*/React__default["default"].createElement("span", null, errorMessage) : /*#__PURE__*/React__default["default"].createElement("span", null), /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(Feature, {
      featureId: featureId,
      featureFlag: featureFlag,
      defaultVal: true
    }, link && link !== '' && /*#__PURE__*/React__default["default"].createElement("button", {
      tabIndex: "0",
      type: "button",
      onClick: linkClickHandler,
      disabled: isDisabled || false
    }, link)))));
  };
  TextInput.propTypes = {
    label: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    name: PropTypes__default["default"].string,
    placeholder: PropTypes__default["default"].string,
    changeHandler: PropTypes__default["default"].func,
    blurHandler: PropTypes__default["default"].func,
    isDisabled: PropTypes__default["default"].bool,
    link: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]),
    errorMessage: PropTypes__default["default"].any,
    linkClickHandler: PropTypes__default["default"].func,
    featureId: PropTypes__default["default"].string,
    autoFocus: PropTypes__default["default"].bool,
    auth: PropTypes__default["default"].object,
    id: PropTypes__default["default"].string,
    disableCopyPaste: PropTypes__default["default"].bool,
    maxLength: PropTypes__default["default"].number,
    autocomplete: PropTypes__default["default"].oneOf(['on', 'off']),
    value: PropTypes__default["default"].string,
    type: PropTypes__default["default"].string
  };
  TextInput.defaultProps = {
    label: '',
    name: '',
    placeholder: '',
    changeHandler: function changeHandler() {
      return null;
    },
    blurHandler: function blurHandler() {
      return null;
    },
    isDisabled: false,
    link: '',
    errorMessage: null,
    linkClickHandler: function linkClickHandler() {
      return null;
    },
    featureId: 'null',
    autoFocus: false,
    auth: {
      featureFlag: {}
    },
    id: 'textinput',
    disableCopyPaste: false,
    maxLength: 255,
    autocomplete: 'on',
    value: '',
    type: 'text'
  };

  exports.CheckBox = CheckBox;
  exports.DateInput = DateInput;
  exports.DateRangeInput = DateRangeInput;
  exports.Dropdown = Dropdown;
  exports.GenericMultiSelectDropdown = GenericMultiSelectDropdown;
  exports.MultipleSelectDropdown = MultipleSelectDropdown;
  exports.PasswordInput = PasswordInput;
  exports.RadioButton = RadioButton;
  exports.SearchableDropdown = SearchableDropdown;
  exports.SwitchInput = SwitchInput;
  exports.TextArea = TextArea;
  exports.TextInput = TextInput;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
